<template>
  <div class="transaction-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title text-capitalize">Financeiro &raquo; {{$route.params.id == newTerm ? 'Cadastrar' : 'Editar'}} {{ termSingular }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <validation-observer ref="transactionForm" v-slot="{ invalid }">
          <b-row>
            <b-col cols="12">
              <div class="box-cj mb-2">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Vincular a paciente e ou Profissional</p>
                    <div class="pretty p-switch p-fill" v-if="transactionForm.attendance_guide_invoice == null">
                      <input type="checkbox" v-model="bind_transaction" />
                      <div class="state p-success">
                        <label></label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content" v-if="bind_transaction">
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Paciente</label>
                      <multiselect ref="multiselectPeople" :preserveSearch="true" v-model="transactionForm.patient" :options="people" track-by="name" label="name" @select="patientSelected" :loading="isLoadingPeople" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPeople" :max-height="200" @search-change="findPeople" :showLabels="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || transactionForm.attendance_guide_start_datetime != null" placeholder="Selecione">
                        <template slot="clear">
                          <div class="multiselect__clear" v-if="transactionForm.patient != null" @mousedown.prevent.stop="transactionForm.patient = null"></div>
                        </template>
                        <template slot="noOptions">
                          <div>
                            Digite para pesquisar seus pacientes...
                          </div>
                        </template>
                        <template slot="noResult" v-if="!isLoadingPeople">
                          <div>
                            Nenhum paciente encontrado...
                          </div>
                        </template>
                      </multiselect>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Profissional</label>
                      <multiselect v-model="transactionForm.professional" :options="professionals" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || transactionForm.attendance_guide_start_datetime != null" placeholder="Selecione">
                        <template slot="clear">
                          <div class="multiselect__clear" v-if="transactionForm.professional != null" @mousedown.prevent.stop="transactionForm.professional = null"></div>
                        </template>
                      </multiselect>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>

            <b-col cols="12">
              <div class="box-cj mb-2">
                <div class="header d-flex justify-content-between">
<!--                  <p class="title">Informações d{{ letter }} {{ termSingular }}</p>-->
                  <p class="title">Lançamento a {{ $route.meta.type == 'INCOME' ? 'receber' : 'pagar' }}</p>
                  <div v-if="transactionForm.attendance_guide_invoice != null">
                    <router-link tag="a" target="_blank" class="print-ico" :to="'/guia-de-atendimento/fatura/' + transactionForm.attendance_guide_invoice.id + '/imprimir'"><i class="far fa-print"></i></router-link>
                  </div>

<!--                  <div class="w-100 d-flex justify-content-between">-->
<!--                    <div>-->
<!--                      Guia de Atendimento #{{ attendanceGuideForm.internal_id }}-->
<!--                    </div>-->
<!--                    <div v-if="attendanceGuideForm.id != null">-->
<!--                      <router-link tag="a" target="_blank" class="print-ico" :to="'/guia-de-atendimento/' + attendanceGuideForm.id + '/imprimir'"><i class="far fa-print"></i></router-link>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
                <div class="content">
                  <b-row>
                    <b-col cols="12" class="mb-2">
                      {{ $route.meta.type == 'INCOME' ? 'Cliente' : 'Fornecedor' }}
                    </b-col>

                    <b-col cols="12" md="6" class="d-flex justify-content-between align-items-center" v-if="!new_payer && transactionForm.payer == null">
                      <multiselect ref="multiselectPayer" :preserveSearch="true" v-model="transactionForm.payer" :options="payers" track-by="name" label="name" @select="payerSelected" :loading="isLoadingPayers" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPayers" :max-height="200" @search-change="findPayers" :showLabels="false" :disabled="!canManage" placeholder="Selecione">
                        <template slot="clear">
                          <div class="multiselect__clear" v-if="transactionForm.payer != null" @mousedown.prevent.stop="transactionForm.payer = null"></div>
                        </template>
                        <template slot="noOptions">
                          <div>
                            Digite para pesquisar seus {{ $route.meta.type == 'INCOME' ? 'clientes' : 'fornecedores' }}...
                          </div>
                        </template>
                        <template slot="noResult" v-if="!isLoadingPayers">
                          <div>
                            Nenhum {{ $route.meta.type == 'INCOME' ? 'cliente' : 'fornecedor' }} encontrado...
                          </div>
                        </template>
                        <template slot="afterList">
                          <li v-if="transactionForm.patient != null" @click="newPayerWithPatientData">
                            <div class="multiselect__option new-patient">
                              <i class="far fa-check-square mr-2"></i>
                              Usar os dados do paciente
                            </div>
                          </li>
                          <li @click="newPayerPatient">
                            <div class="multiselect__option new-patient">
                              <i class="far fa-search mr-2"></i>
                              Pesquisar paciente
                            </div>
                          </li>
                          <li @click="newPayer">
                            <div class="multiselect__option new-patient">
                              <i class="far fa-plus-circle mr-2"></i>
                              Adicionar novo {{ $route.meta.type == 'INCOME' ? 'cliente' : 'fornecedor' }}
                            </div>
                          </li>
                        </template>
                      </multiselect>
                    </b-col>
                    <template v-if="new_payer_patient && payer_patient == null">
                      <b-col cols="12" md="6">
                        <label class="cj-label">Pesquisar paciente</label>
                        <multiselect ref="multiselectPayerPatient" :preserveSearch="true" v-model="payer_patient" :options="payerPatients" track-by="name" label="name" @select="payerPatientSelected" :loading="isLoadingPayerPatients" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPeople" :max-height="200" @search-change="findPayerPatients" :showLabels="false" :disabled="!canManage" placeholder="Selecione">
                          <template slot="clear">
                            <div class="multiselect__clear" v-if="payer_patient != null" @mousedown.prevent.stop="payer_patient = null"></div>
                          </template>
                          <template slot="noOptions">
                            <div>
                              Digite para pesquisar seus pacientes...
                            </div>
                          </template>
                          <template slot="noResult" v-if="!isLoadingPeople">
                            <div>
                              Nenhum paciente encontrado...
                            </div>
                          </template>
                        </multiselect>
                      </b-col>
                      <b-col>
                        <label class="cj-label">&nbsp;</label><br>
                        <b-button class="ml-2" size="sm" variant="primary" @click="changePayer" :disabled="!canManage"><i class="fas fa-exchange-alt mr-1"></i>Trocar</b-button>
                      </b-col>
                    </template>
                  </b-row>
                  <template v-if="(new_payer && !new_payer_patient) || transactionForm.payer != null || transactionForm.payer_name != null">
<!--                    <b-row class="mb-2" v-if="!new_payer_patient && transactionForm.patient != null && transactionForm.payer == null">-->
<!--                      <b-col>-->
<!--                        <div class="pretty p-switch p-fill mr-0">-->
<!--                          <input type="checkbox" v-model="transactionForm.use_patient_data" />-->
<!--                          <div class="state p-success">-->
<!--                            <label><span>Usar dados do(a) paciente</span></label>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </b-col>-->
<!--                    </b-row>-->
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">CPF / CNPJ</label>
                        <validation-provider name="CPF / CNPJ" :rules="{ cpfOrCnpj: true }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="transactionForm.payer_document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##', '##.###.###/####-##']" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && (!transactionForm.edit_payer || current_payer_has_document))"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col v-if="(new_payer || transactionForm.payer != null || transactionForm.payer_name != null) && transactionForm.nfse == null">
                        <label class="cj-label">&nbsp;</label><br>
                        <b-button class="ml-2" size="sm" variant="primary" @click="changePayer" :disabled="!canManage"><i class="fas fa-exchange-alt mr-1"></i>Trocar {{ $route.meta.type == 'INCOME' ? 'cliente' : 'fornecedor' }}</b-button>
                        <b-button class="ml-2" size="sm" variant="secondary" v-if="(transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer" @click="transactionForm.edit_payer = true"><i class="fas fa-edit mr-1"></i>Editar cadastro</b-button>
                      </b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">{{transactionForm.payer_document && transactionForm.payer_document.length === 18 ? 'Razão social' : 'Nome'}}</label>
                        <b-form-input type="text" v-model="transactionForm.payer_name" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                      </b-col>
                      <template v-if="transactionForm.payer_document && transactionForm.payer_document.length === 18">
                        <b-col>
                          <label class="cj-label">Nome fantasia</label>
                          <b-form-input type="text" v-model="transactionForm.payer_fantasy_name" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Inscrição municipal</label>
                          <validation-provider name="inscrição municipal" :rules="{ required: false }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="transactionForm.payer_city_inscription" :class="{ 'error': errors.length > 0 }" autocomplete="off" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Inscrição estadual</label>
                          <validation-provider name="inscrição estadual" :rules="{ required: false }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="transactionForm.payer_state_inscription" :class="{ 'error': errors.length > 0 }" autocomplete="off" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col cols="12"></b-col>
                      </template>
                      <b-col>
                        <label class="cj-label">E-mail</label>
                        <b-form-input type="email" v-model="transactionForm.payer_email" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Telefone</label>
                        <b-form-input type="text" v-model="transactionForm.payer_telephone" v-mask="(transactionForm.payer_telephone != null && transactionForm.payer_telephone.length == 15)?'(##) #####-####':'(##) ####-#####'" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Celular</label>
                        <b-form-input type="text" v-model="transactionForm.payer_cellphone" v-mask="(transactionForm.payer_cellphone != null && transactionForm.payer_cellphone.length == 15)?'(##) #####-####':'(##) ####-#####'" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                      </b-col>
                      <b-col v-if="transactionForm.payer_document && transactionForm.payer_document.length === 18"></b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">CEP</label>
                        <b-form-input type="tel" v-model="transactionForm.payer_zip_code" v-mask="'#####-###'" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)" v-on:blur="findCep(transactionForm.payer_zip_code)"></b-form-input>
                      </b-col>
                      <b-col cols="6">
                        <label class="cj-label">Endereço</label>
                        <b-form-input type="text" v-model="transactionForm.payer_address" ref="address" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Número</label>
                        <b-form-input type="tel" v-model="transactionForm.payer_number" ref="number" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Complemento</label>
                        <b-form-input type="text" v-model="transactionForm.payer_complement" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Bairro</label>
                        <b-form-input type="text" v-model="transactionForm.payer_neighborhood" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Cidade</label>
                        <b-form-input type="text" v-model="transactionForm.payer_city" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Estado</label>
                        <validation-provider name="estado" :rules="{ required: false, length: 2 }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="transactionForm.payer_state" :class="{ 'error': errors.length > 0 }" autocomplete="off" :disabled="!canManage || ((transactionForm.payer != null || payer_patient != null) && !transactionForm.edit_payer)"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </template>
                  <hr>
                  <b-row class="mb-2">
                    <b-col cols="12" class="mb-2">
                      Detalhes do lançamento
                    </b-col>
                    <b-col cols="12" md="6">
                      <label class="cj-label">Descrição</label>
                      <validation-provider name="descrição" :rules="{ required: true }" v-slot="{ errors }">
                        <b-input-group>
                          <b-input-group-prepend is-text v-if="transactionForm.description_prefix != null && transactionForm.description_prefix !== ''">
                            <template v-if="transactionForm.attendance_guide_internal_id != null && (helpers.isOwner() || user.person.type == 'SECRETARY' || helpers.checkPermission('attendance-guides', 'can_see', true))">
                              <router-link tag="a" target="_blank" :to="'/guias-de-atendimento?internal_id=' + transactionForm.attendance_guide_internal_id">
                                {{transactionForm.description_prefix.split(' - ')[0]}}
                              </router-link>
                              <template v-if="transactionForm.description_prefix.indexOf(' - ') >= 0">
                                &nbsp;- {{transactionForm.description_prefix.split(' - ')[1]}}
                              </template>
                            </template>
                            <template v-else>
                              {{transactionForm.description_prefix}}
                            </template>
                          </b-input-group-prepend>
                          <b-form-input type="text" v-model="transactionForm.description" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        </b-input-group>

<!--                        <b-form-input type="text" v-model="transactionForm.description" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>-->
<!--                        <b-form-input type="text" v-model="transactionForm.description" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>-->
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Vencimento</label>
                      <validation-provider name="vencimento" :rules="{ required: !split }" v-slot="{ errors }">
                        <date-picker name="date" v-model="transactionForm.charge_date" v-mask="'##/##/####'" :disabled="transactionForm.nfse != null || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup) || split" :config="datePickerOptions" :class="{ 'error': errors.length > 0, 'text-danger': chargeDateFieldClass == 'danger', 'text-warning-darker': chargeDateFieldClass == 'warning' }" autocomplete="off"></date-picker>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <validation-provider name="valor final" :rules="{ required: true }" v-slot="{ errors }">
                        <label class="cj-label">Valor final</label>
                        <money v-model="transactionForm.value" class="form-control mb-2" :disabled="true" :class="{ 'error': errors.length > 0 }"></money>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>

                    <b-col v-if="$route.params.id != newTerm">
                      <label class="cj-label">Status</label>
                      <b-form-input type="text" :value="transactionForm.discharged ? ($route.meta.type == 'INCOME'?'Recebido':'Pago') : ($route.meta.type == 'INCOME'?'Não Recebido':'Não Pago')" disabled></b-form-input>

<!--                      <div class="pretty positive p-default">-->
<!--                        <input type="checkbox" v-model="transactionForm.discharged" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" />-->
<!--                        <div class="state p-success">-->
<!--                          <label class="cj-label">{{ ($route.meta.type == 'INCOME')?'Recebido':'Pago' }}</label>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <validation-provider name="data da quitação" :rules="{ required: transactionForm.discharged }" v-slot="{ errors }">-->
<!--                        <date-picker name="date" v-model="transactionForm.discharge_date" v-mask="'##/##/####'" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) && !transactionForm.discharged)" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>-->
<!--                        <span class="cj-error">{{ errors[0] }}</span>-->
<!--                      </validation-provider>-->
                    </b-col>
                    <b-col v-else></b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                        <label class="cj-label">Valor</label>
                        <money v-model="transactionForm.original_value" class="form-control mb-2" :disabled="transactionForm.nfse != null || transactionForm.attendance_guide_invoice != null || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></money>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <validation-provider name="desconto" :rules="{ required: true, valueLowerOrEqualValue:(transactionForm.discount_is_percent ? false : {targetValue:transactionForm.original_value, targetName:'valor'}), valueLowerOrEqual100:transactionForm.discount_is_percent }" v-slot="{ errors }">
                        <label class="cj-label">Desconto</label>
                        <b-input-group>
                          <money v-model="transactionForm.discount" :prefix="transactionForm.discount_is_percent ? '' : 'R$ '" :suffix="transactionForm.discount_is_percent ? ' %' : ''" :maxlength="transactionForm.discount_is_percent ? 7 : 50" class="form-control mb-2" :disabled="transactionForm.nfse != null || (transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup) || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></money>
                          <template #append>
                            <b-dropdown :text="transactionForm.discount_is_percent ? '%' : 'R$'" :disabled="transactionForm.nfse != null || (transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup) || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))">
                              <b-dropdown-item @click="transactionForm.discount_is_percent = !transactionForm.discount_is_percent">{{ transactionForm.discount_is_percent ? 'R$' : '%' }}</b-dropdown-item>
                            </b-dropdown>
                          </template>
                        </b-input-group>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <validation-provider name="forma de pagamento" :rules="{ required: !split }" v-slot="{ errors }">
                        <label class="cj-label">Forma de Pagamento</label>
                        <multiselect v-model="transactionForm.payment_method" :options="payment_methods" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="transactionForm.nfse != null || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup) || split" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <validation-provider name="tipo de pagamento" :rules="{ required: $route.params.id == newTerm || (transactionForm.attendance_guide_invoice != null && !transactionForm.attendance_guide_invoice.finished_setup) }" v-slot="{ errors }">
                        <label class="cj-label">Tipo de pagamento</label>
                        <multiselect v-model="transactionForm.payment_type" :options="paymentTypeOptions" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione" :disabled="!($route.params.id == newTerm || (transactionForm.attendance_guide_invoice != null && !transactionForm.attendance_guide_invoice.finished_setup))" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <validation-provider name="categoria" :rules="{ required: false }" v-slot="{ errors }">
                        <label class="cj-label">Categoria</label>
                        <multiselect v-model="transactionForm.category" :options="categories" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" :disabled="transactionForm.nfse != null || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" placeholder="Selecione" :class="{ 'error': errors.length > 0 }">
                          <template slot="clear">
                            <div class="multiselect__clear" v-if="transactionForm.category != null" @mousedown.prevent.stop="transactionForm.category = null"></div>
                          </template>
                          <template slot="noOptions">
                            Nenhuma cadastrada.
                          </template>
                          <template slot="afterList">
                            <li @click="showCategoryModal(module)">
                              <div class="multiselect__option new-patient">
                                <i class="far fa-plus-circle mr-2"></i>
                                Adicionar nova
                              </div>
                            </li>
                          </template>
                        </multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Data de lançamento</label>
                      <validation-provider name="data de lançamento" :rules="{ required: true }" v-slot="{ errors }">
                        <date-picker name="date" v-model="transactionForm.registration_date" v-mask="'##/##/####'" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || transactionForm.attendance_guide_invoice != null" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col v-if="$route.meta.type != 'INCOME'">
                      <label class="cj-label">Centro de Custo</label>
                      <multiselect v-model="transactionForm.cost_center" :options="cost_centers" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" placeholder="Selecione">
                        <template slot="clear">
                          <div class="multiselect__clear" v-if="transactionForm.cost_center != null" @mousedown.prevent.stop="transactionForm.cost_center = { id: null, name: '' }"></div>
                        </template>
                        <template slot="noOptions">
                          Nenhum cadastrado.
                        </template>
                        <template slot="afterList">
                          <li @click="showCategoryModal('cost_center')">
                            <div class="multiselect__option new-patient">
                              <i class="far fa-plus-circle mr-2"></i>
                              Adicionar novo
                            </div>
                          </li>
                        </template>
                      </multiselect>
                    </b-col>
<!--                    <b-col>-->
<!--                      <label class="cj-label">-->
<!--                        Conta-->
<!--                      </label>-->
<!--                      <validation-provider name="conta" :rules="{ required: true }" v-slot="{ errors }">-->
<!--                        <multiselect v-model="transactionForm.bank_account" :options="bank_accounts" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" placeholder="Selecione" :class="{ 'error': errors.length > 0 }">-->
<!--                          <template slot="noOptions">-->
<!--                            Nenhuma cadastrada.-->
<!--                          </template>-->
<!--                          <template slot="afterList">-->
<!--                            <li @click="showBankAccountModal(true)">-->
<!--                              <div class="multiselect__option new-patient">-->
<!--                                <i class="far fa-plus-circle mr-2"></i>-->
<!--                                Adicionar nova-->
<!--                              </div>-->
<!--                            </li>-->
<!--                          </template>-->
<!--                        </multiselect>-->
<!--                        <span class="cj-error">{{ errors[0] }}</span>-->
<!--                      </validation-provider>-->
<!--                    </b-col>-->
                    <b-col>
                      <label class="cj-label">Unidade</label>
                      <validation-provider name="unidade" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="transactionForm.unit" :options="units" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" :disabled="transactionForm.nfse != null || transactionForm.attendance_guide_invoice != null || transactionForm.payments.some(p => p.invoice != null) || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col></b-col>
                    <b-col v-if="$route.meta.type == 'INCOME'"></b-col>
                    <b-col cols="12">
                      <label class="cj-label">Observações</label>
                      <b-form-textarea v-model="transactionForm.notes" rows="2" max-rows="5" no-resize :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))"></b-form-textarea>
                    </b-col>
                  </b-row>
                  <hr v-if="split || repeat">
                  <template v-if="split">
                    <b-row class="mb-2 justify-content-center align-items-center">
                      <b-col cols="auto">
                        <label class="text1">Quantidade de parcelas / lançamentos</label>
                      </b-col>
                      <b-col cols="auto">
                        <validation-provider name="número de parcelas" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="number" min="2" max="360" step="1" v-model="splitForm.times" class="text-center" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col cols="auto">
                        <b-button class="ml-2" size="sm" variant="primary" v-b-tooltip.hover title="Recalcular valores das parcelas" @click="recalculateInstallments" :disabled="!canManage"><i class="fas fa-sync"></i></b-button>
                      </b-col>
                    </b-row>
                    <template v-for="installment in splitForm.installments">
                      <hr v-if="installment.index > 1" :key="'hr-installment' + installment.index">
                      <b-row :key="'installment' + installment.index" class="justify-content-center align-items-center">
                        <b-col cols="auto">
                          <label class="text1 mt-2">Parcela {{installment.index}}</label>
                        </b-col>
                        <b-col>
                          <validation-provider :name="'valor - parcela '+installment.index" :rules="{ required: true }" v-slot="{ errors }">
                            <label class="cj-label">Valor</label>
                            <money v-model="installment.value" class="form-control" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" :class="{ 'error': errors.length > 0 }"></money>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Vencimento</label>
                          <validation-provider :name="'vencimento - parcela '+installment.index" :rules="{ required: true }" v-slot="{ errors }">
                            <date-picker name="date" v-model="installment.charge_date" v-mask="'##/##/####'" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <validation-provider :name="'forma de pagamento - parcela '+installment.index" :rules="{ required: true }" v-slot="{ errors }">
                            <label class="cj-label">Forma de Pagamento</label>
                            <multiselect v-model="installment.payment_method" :options="payment_methods" :ref="'installmentPaymentMethod'+installment.index" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit)) || (!helpers.isOwner() && transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.finished_setup)" placeholder="Selecione" @select="installmentPaymentMethodSelected(installment)" :class="{ 'error': errors.length > 0 }"></multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </template>
                  </template>
                  <template v-if="repeat">
                    <b-row class="mb-2">
                      <b-col class="text-center">
                        <label class="text1">Repetir</label>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2 justify-content-center align-items-center">
                      <b-col cols="3">
                        <validation-provider name="forma de pagamento" :rules="{ required: true }" v-slot="{ errors }">
                          <multiselect v-model="repeatForm.type" :options="repeatOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col cols="auto">
                        <label class="text1">Encerrar repetição após</label>
                      </b-col>
                      <b-col cols="auto">
                        <validation-provider name="número de repetições" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="number" min="1" max="360" step="1" v-model="repeatForm.times" class="text-center" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col cols="auto">
                        <label class="text1">vezes</label>
                      </b-col>
                    </b-row>
                  </template>

                  <hr v-if="transactionForm.attendance_guide_invoice_items.length > 0">
                  <b-row v-if="transactionForm.attendance_guide_invoice_items.length > 0">
                    <b-col cols="12" class="mb-2">
                      Guia de atendimento #{{ transactionForm.attendance_guide_internal_id }}
                    </b-col>
                    <b-col cols="12">
                      <div>
                        <label class="text1 mb-1">Data do atendimento: {{ transactionForm.attendance_guide_start_datetime }}</label>
                      </div>
                      <div>
                        <label class="text1">Convênio: {{ transactionForm.attendance_guide_health_plan }}</label>
                      </div>
                      <div v-if="transactionForm.attendance_guide_invoice != null && transactionForm.attendance_guide_invoice.authorization_code != null">
                        <label class="text1">Número de autorização: {{ transactionForm.attendance_guide_invoice.authorization_code }}</label>
                      </div>
                      <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                        <thead>
                        <tr>
                          <th v-if="transactionForm.professional.is_dentist">Dente/Área</th>
                          <th v-if="transactionForm.professional.is_dentist">Face(s)</th>
                          <th>Procedimento</th>
                          <th>Quantidade</th>
                          <th>Valor</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) of transactionForm.attendance_guide_invoice_items" :key="index">
                          <td v-if="transactionForm.professional.is_dentist">{{ item.tooth != null ? item.tooth : '-' }}</td>
                          <td v-if="transactionForm.professional.is_dentist">{{ item.faces != null ? item.faces : '-' }}</td>
                          <td>{{ item.procedure.name }}</td>
                          <td>{{ item.amount }}</td>
                          <td>R$ {{ formatPrice(item.value) }}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td></td>
                            <td class="text-right">Subtotal:</td>
                            <td>
                              R$ {{ formatPrice(transactionForm.attendance_guide_invoice.original_value) }}
                            </td>
                          </tr>
                          <tr>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td></td>
                            <td class="text-right">Desconto:</td>
                            <td v-if="transactionForm.attendance_guide_invoice.finished_setup">
                              - {{ (transactionForm.attendance_guide_invoice.discount_is_percent ? '' : 'R$ ') + formatPrice(transactionForm.attendance_guide_invoice.discount) + (transactionForm.attendance_guide_invoice.discount_is_percent ? ' %' : '') }}
                            </td>
                            <td v-else>
                              - {{ (transactionForm.discount_is_percent ? '' : 'R$ ') + formatPrice(transactionForm.discount) + (transactionForm.discount_is_percent ? ' %' : '') }}
                            </td>
                          </tr>
                          <tr>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td></td>
                            <td class="text-right">Total:</td>
                            <td v-if="transactionForm.attendance_guide_invoice.finished_setup">
                              R$ {{ formatPrice(transactionForm.attendance_guide_invoice.value) }}{{transactionForm.attendance_guide_invoice.installments > 1 ? (' (' + transactionForm.attendance_guide_invoice.installments + ' parcelas)') : ''}}
<!--                              <span v-if="transactionForm.discharged" class="text-success ml-4">RECEBIDO</span>-->
                            </td>
                            <td v-else>
                              R$ {{ formatPrice(transactionForm.value) }}{{split && splitForm.times > 1 ? (' (' + splitForm.times + ' parcelas)') : ''}}
<!--                              <span v-if="transactionForm.discharged" class="text-success ml-4">RECEBIDO</span>-->
                            </td>
                          </tr>
                          <tr>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td v-if="transactionForm.professional.is_dentist"></td>
                            <td></td>
                            <td class="text-right">Comissão:</td>
                            <td v-if="transactionForm.attendance_guide_invoice.finished_setup">
                              R$ {{ formatPrice(transactionForm.professional.commission_percentage * transactionForm.attendance_guide_invoice.value / 100.0) }}
                            </td>
                            <td v-else>
                              R$ {{ formatPrice(transactionForm.professional.commission_percentage * transactionForm.value / 100.0) }}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>

            <b-col cols="12">
              <div class="box-cj mb-2">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Pagamento(s)</p>
                  </div>
                </div>
                <div class="content">
                  <b-row>
                    <b-col cols="12" v-if="transactionForm.payments.length > 0 || transactionForm.first_transaction_payments.length > 0">
                      <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                        <thead>
                        <tr>
                          <th>Data</th>
                          <th>Forma de pagamento</th>
                          <th v-if="$route.meta.type == 'INCOME'">Parcelas</th>
                          <th>Conta</th>
                          <th>Valor</th>
                          <th>Valor final</th>
                          <th v-if="$route.meta.type == 'INCOME'">Transação</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(payment, index) in transactionForm.payments" :key="'payment'+index">
                          <td>{{ moment(payment.date).format('DD/MM/YYYY') }}</td>
                          <td>{{ payment.payment_method ? payment.payment_method.name : '' }}</td>
                          <td v-if="$route.meta.type == 'INCOME'">{{ payment.invoice != null ? payment.invoice.installments : 1 }}</td>
                          <td>{{ payment.bank_account ? payment.bank_account.name : '' }}</td>
                          <td>R$ {{ formatPrice(payment.original_value) }}</td>
                          <td>R$ {{ formatPrice(payment.value) }}</td>
                          <td v-if="$route.meta.type == 'INCOME'">
                            <router-link v-if="payment.invoice != null" target="_blank" tag="a" class="btn btn-primary btn-sm" :to="'/financeiro/transacoes/'+payment.invoice.id">
                              <i class="far fa-money-check-alt"></i>
                            </router-link>
                          </td>
                          <td>
                            <b-button size="sm" variant="primary" @click="showPaymentModal(payment)" v-if="canEdit" class="mr-1"><i :class="'far ' + (lockedPaymentFields ? 'fa-eye' : 'fa-pencil-alt')"></i></b-button>
                            <b-button size="sm" variant="danger" v-if="!lockedPaymentFields" @click="deletePayment(index)"><i class="far fa-trash-alt"></i></b-button>
                          </td>
                        </tr>
                        <tr v-for="(payment, index) in transactionForm.first_transaction_payments" :key="'first_transaction_payments'+index">
                          <td>{{ moment(payment.date).format('DD/MM/YYYY') }}</td>
                          <td>{{ payment.payment_method ? payment.payment_method.name : '' }}</td>
                          <td v-if="$route.meta.type == 'INCOME'">{{ payment.invoice != null ? payment.invoice.installments : 1 }}</td>
                          <td>{{ payment.bank_account ? payment.bank_account.name : '' }}</td>
                          <td>R$ {{ formatPrice(payment.original_value) }}</td>
                          <td>R$ {{ formatPrice(payment.value) }}</td>
                          <td v-if="$route.meta.type == 'INCOME'">
                            <router-link v-if="payment.invoice != null" target="_blank" tag="a" class="btn btn-primary btn-sm" :to="'/financeiro/transacoes/'+payment.invoice.id">
                              <i class="far fa-money-check-alt"></i>
                            </router-link>
                          </td>
                          <td>
                            <b-button size="sm" variant="primary" @click="showPaymentModal(payment)" v-if="canEdit" class="mr-1"><i class="far fa-eye"></i></b-button>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                          <td :colspan="$route.meta.type == 'INCOME' ? 4 : 3" class="text-right">Total:</td>
                          <td>R$ {{ formatPrice(transactionForm.payments.reduce((total, item) => total + item.original_value, 0) + transactionForm.first_transaction_payments.reduce((total, item) => total + item.original_value, 0)) }}</td>
                          <td>R$ {{ formatPrice(transactionForm.payments.reduce((total, item) => total + item.value, 0) + transactionForm.first_transaction_payments.reduce((total, item) => total + item.value, 0)) }}</td>
                          <td :colspan="$route.meta.type == 'INCOME' ? 2 : 1"></td>
                        </tr>
                        </tfoot>
                      </table>
                    </b-col>
                    <b-col cols="12" class="text-center" v-if="!lockedPaymentFields">
                      <b-button variant="success" :disabled="!canPerformAction || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" @click="showPaymentModal(null)">Informar pagamento</b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>

            <b-col cols="12" v-if="transactionForm.nfse != null">
              <div class="box-cj mb-2">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Nota Fiscal</p>
                  </div>
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">ID da NF</label><br/>
                      <span class="preview">{{ transactionForm.nfse.totvs_id }}</span>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Data</label><br/>
                      <span class="preview">{{ moment(transactionForm.nfse.created_at).format('DD/MM/YYYY') }}</span>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Valor</label><br/>
                      <span class="preview">R$ {{ formatPrice(transactionForm.nfse.value) }}</span>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Status</label><br/>
                      <span class="preview">{{ nfseStatusOptions.find(g => g.value == transactionForm.nfse.status).name }}</span>
                    </b-col>
                  </b-row>
                  <b-row v-if="transactionForm.nfse.number != null">
                    <b-col>
                      <label class="cj-label">Número da NF</label><br/>
                      <span class="preview">{{ transactionForm.nfse.number }}</span>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Código de verificação</label><br/>
                      <span class="preview">{{ transactionForm.nfse.totvs_verification_code }}</span>
                    </b-col>
                    <b-col v-if="transactionForm.nfse.totvs_direct_url != null">
                      <label class="cj-label">Link da prefeitura</label><br/>
                      <a target="_blank" class="btn btn-primary btn-sm" :href="transactionForm.nfse.totvs_direct_url"><i class="far fa-sm fa-download mr-2"></i> Baixar</a>
<!--                      <router-link tag="a" target="_blank" class="btn btn-primary btn-sm" :to="transactionForm.nfse.totvs_direct_url"><i class="far fa-sm fa-download mr-2"></i> Baixar</router-link>-->
                    </b-col>
                    <b-col v-else-if="transactionForm.nfse.totvs_city_url != null">
                      <label class="cj-label">Link da prefeitura</label><br/>
                      <a target="_blank" class="btn btn-primary btn-sm" :href="transactionForm.nfse.totvs_city_url"><i class="far fa-sm fa-external-link-alt mr-2"></i> link-alt</a>
<!--                      <router-link tag="a" target="_blank" class="btn btn-primary btn-sm" :to="transactionForm.nfse.totvs_city_url"><i class="fas fa-sm fa-external-link-alt mr-2"></i> Acessar</router-link>-->
                    </b-col>
                    <b-col v-else></b-col>
                    <b-col></b-col>
                  </b-row>
                </div>
              </div>
            </b-col>

            <b-col cols="12" v-if="transactionForm.other_installment_transactions.length > 0">
              <div class="box-cj mb-2">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Outra(s) parcela(s)</p>
                  </div>
                </div>
                <div class="content">
                  <b-row>
                    <b-col cols="12">
                      <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                        <thead>
                          <tr>
                            <th>{{ $route.meta.type == 'INCOME' ? 'Cliente' : 'Fornecedor' }}</th>
                            <th>Descrição</th>
                            <th>Valor</th>
                            <th>Vencimento</th>
                            <th>Status</th>
                            <th>Baixa</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="otherInstallmentTransaction in transactionForm.other_installment_transactions" :key="otherInstallmentTransaction.id">
                            <td>{{ (otherInstallmentTransaction.payer_name != null)?otherInstallmentTransaction.payer_name:(otherInstallmentTransaction.patient?otherInstallmentTransaction.patient.name:'-') }}</td>
                            <td>{{ otherInstallmentTransaction.description }}</td>
                            <td>R$ {{ formatPrice(otherInstallmentTransaction.value) }}</td>
                            <td>{{ otherInstallmentTransaction.charge_date != null ? moment(otherInstallmentTransaction.charge_date).format('DD/MM/YYYY') : '' }}</td>
                            <td>{{ otherInstallmentTransaction.deleted_at != null ? 'Excluído' : (!otherInstallmentTransaction.discharged?'Não ':'') }} {{ otherInstallmentTransaction.deleted_at != null ? '' : dischargedTerm.replace(/^./, dischargedTerm[0].toUpperCase()) }}</td>
                            <td>{{ otherInstallmentTransaction.discharge_date != null ? moment(otherInstallmentTransaction.discharge_date).format('DD/MM/YYYY') : '' }}</td>
                            <td>
                              <router-link v-if="otherInstallmentTransaction.deleted_at == null" target="_blank" tag="a" class="btn btn-primary btn-sm" :to="'/financeiro/'+url+'/'+otherInstallmentTransaction.id">
                                <i class="far fa-folder-open"></i>
                              </router-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>

            <b-col cols="12" v-if="((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit) || canRemove)">
              <div class="box-cj">
                <div class="footer">
                  <template v-if="transactionForm.attendance_guide_invoice != null && !transactionForm.attendance_guide_invoice.finished_setup">
                    <b-button variant="warning" class="mr-3" :disabled="!canPerformAction || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" @click="saveInvoiceDraft">Salvar rascunho</b-button>
                    <b-button variant="primary" class="mr-3" :disabled="!canPerformAction || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" @click="finishInvoiceSetup">Finalizar faturamento</b-button>
                  </template>
                  <template v-else>
                    <b-button variant="primary" class="mr-3" :disabled="!canPerformAction || !((transactionForm.id == null && canAdd) || (transactionForm.id != null && canEdit))" @click="saveTransaction">Salvar</b-button>

                    <b-button v-if="$route.meta.type == 'INCOME' && transactionForm.id != null && transactionForm.attendance_guide_invoice != null && transactionForm.nfse == null && user.person.client.enable_mandic_nf" variant="info" class="mr-3" :disabled="!canPerformAction || !canEdit" @click="issueTransactionNf">Emitir NF</b-button>
                    <b-button v-if="$route.meta.type == 'INCOME' && transactionForm.id != null && transactionForm.attendance_guide_invoice != null && transactionForm.nfse != null && user.person.client.enable_mandic_nf" variant="danger" class="mr-3" :disabled="!canPerformAction || !canEdit" @click="deleteTransactionNf">Excluir NF</b-button>
                  </template>
                  <b-button variant="danger" v-if="transactionForm.id != null && transactionForm.nfse == null && canRemove" @click="deleteTransaction">Excluir</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-container>

    <b-modal id="bank-account-modal" class="bank-account-modal" :modalClass="'bank-account-modal'" @hidden="resetBankAccountModal">
      <template slot="modal-header">
        Adicionar nova conta
      </template>
      <template slot="default">
        <validation-observer ref="bankAccountForm" v-slot="{ invalid }">
          <b-row>
            <b-col>
              <label class="cj-label">Nome</label>
              <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                <b-form-input type="text" v-model="bankAccountForm.name" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
<!--            <b-col>-->
<!--              <label class="cj-label">Saldo</label>-->
<!--              <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">-->
<!--                <money v-model="bankAccountForm.opening_balance" class="form-control" :class="{ 'error': errors.length > 0 }"></money>-->
<!--                <span class="cj-error">{{ errors[0] }}</span>-->
<!--              </validation-provider>-->
<!--            </b-col>-->
          </b-row>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('bank-account-modal')">Fechar</b-button>
        <b-button size="sm" variant="success" @click="saveBankAccount">Adicionar</b-button>
      </template>
    </b-modal>

    <b-modal id="category-modal" class="category-modal" :modalClass="'category-modal'" @hidden="resetCategoryModal">
      <template slot="modal-header">
        Adicionar {{ (categoryForm.type == 'cost_center')?'novo centro de custo':'nova categoria' }}
      </template>
      <template slot="default">
        <validation-observer ref="categoryForm" v-slot="{ invalid }">
          <b-row>
            <b-col>
              <label class="cj-label">Nome</label>
              <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                <b-form-input type="text" v-model="categoryForm.name" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('category-modal')">Fechar</b-button>
        <b-button size="sm" variant="success" @click="saveCategory">Adicionar</b-button>
      </template>
    </b-modal>


    <b-modal size="xl" id="payment-modal" class="payment-modal" :modalClass="'payment-modal'" @hidden="resetPaymentModal">
      <template slot="modal-header">
        {{ paymentForm.id == null ? 'Informar' : 'Editar' }} pagamento
      </template>
      <template slot="default">
        <validation-observer ref="paymentForm" v-slot="{ invalid }">
          <b-row class="mb-2">
            <b-col>
              <validation-provider name="forma de pagamento" :rules="{ required: true }" v-slot="{ errors }">
                <label class="cj-label">Forma de Pagamento</label>
                <multiselect v-model="paymentForm.payment_method" :options="payment_payment_methods" :disabled="lockedPaymentFields || lockedPaymentMethodField" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col>
              <label class="cj-label">
                Conta
              </label>
              <validation-provider name="conta" :rules="{ required: true }" v-slot="{ errors }">
                <multiselect v-model="paymentForm.bank_account" :options="bank_accounts" :disabled="lockedPaymentFields" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione" :class="{ 'error': errors.length > 0 }">
                  <template slot="noOptions">
                    Nenhuma cadastrada.
                  </template>
                  <template slot="afterList">
                    <li @click="showBankAccountModal(false)">
                      <div class="multiselect__option new-patient">
                        <i class="far fa-plus-circle mr-2"></i>
                        Adicionar nova
                      </div>
                    </li>
                  </template>
                </multiselect>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col>
              <label class="cj-label">Data</label>
              <validation-provider name="data" :rules="{ required: true }" v-slot="{ errors }">
                <date-picker name="date" v-model="paymentForm.date" v-mask="'##/##/####'" :disabled="lockedPaymentFields" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                <label class="cj-label">Valor</label>
                <money v-model="paymentForm.original_value" class="form-control mb-2" :disabled="lockedPaymentFields" :class="{ 'error': errors.length > 0 }"></money>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider name="desconto" :rules="{ required: true }" v-slot="{ errors }">
                <label class="cj-label">Desconto</label>
                <money v-model="paymentForm.discount" class="form-control mb-2" :disabled="lockedPaymentFields" :class="{ 'error': errors.length > 0 }"></money>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider name="juros" :rules="{ required: true }" v-slot="{ errors }">
                <label class="cj-label">Juros</label>
                <money v-model="paymentForm.interest" class="form-control mb-2" :disabled="lockedPaymentFields" :class="{ 'error': errors.length > 0 }"></money>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider name="multa" :rules="{ required: true }" v-slot="{ errors }">
                <label class="cj-label">Multa</label>
                <money v-model="paymentForm.fine" class="form-control mb-2" :disabled="lockedPaymentFields" :class="{ 'error': errors.length > 0 }"></money>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col>
              <validation-provider name="valor final" :rules="{ required: true }" v-slot="{ errors }">
                <label class="cj-label">Valor final</label>
                <money v-model="paymentForm.value" class="form-control mb-2" :disabled="true" :class="{ 'error': errors.length > 0 }"></money>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="$route.meta.type == 'INCOME' && paymentForm.payment_method != null && ['Cartão de Crédito', 'Cartão de Débito', 'Pix'].indexOf(paymentForm.payment_method.name) >= 0">
            <b-col v-if="paymentForm.invoice != null">
              <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                <thead>
                <tr>
                  <th>Data</th>
                  <th>Descrição</th>
                  <th>Método de pagamento</th>
                  <th>Parcelas</th>
                  <th>Valor</th>
                  <th>Identificador</th>
                  <th v-if="!lockedPaymentFields"></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{ moment(paymentForm.invoice.paid_at).format('DD/MM/YYYY') }}</td>
                  <td>{{ paymentForm.invoice.appointment_id != null ? ('Agendamento ' + paymentForm.invoice.patient) : '-' }}</td>
                  <td>{{ paymentForm.invoice.payment_method == 'boleto' ? 'Boleto' : (paymentForm.invoice.payment_method == 'pix' ? 'Pix' : (paymentForm.invoice.card_brand + ' ' + paymentForm.invoice.card_bin + ' ****')) }}</td>
                  <td>{{ paymentForm.invoice.installments }}</td>
                  <td>R$ {{ formatPrice(paymentForm.invoice.value_in_cents/100.0) }}</td>
                  <td>{{ paymentForm.invoice.payment_method == 'boleto' ? paymentForm.invoice.boleto_document_number : (paymentForm.invoice.payment_method == 'Pix' ? paymentForm.invoice.pix_id : (paymentForm.invoice.card_nsu != null ? (paymentForm.invoice.card_nsu + '-' + paymentForm.invoice.card_auth) : '')) }}</td>
                  <td v-if="!lockedPaymentFields">
                    <b-button size="sm" variant="danger" @click="paymentForm.invoice = null"><i class="far fa-trash-alt"></i></b-button>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
            <b-col v-else-if="!lockedPaymentFields" cols="12" class="text-center">
              <b-button variant="success" @click="showSelectInvoiceModal()">Selecionar a transação</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <label class="cj-label">Observações</label>
              <b-form-input type="text" v-model="paymentForm.notes" :disabled="lockedPaymentFields" maxlength="500" autocomplete="off"></b-form-input>
            </b-col>
          </b-row>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('payment-modal')">Fechar</b-button>
        <b-button size="sm" variant="success" v-if="!lockedPaymentFields" @click="savePayment">Salvar</b-button>
      </template>
    </b-modal>

    <b-modal size="xl" id="select-invoice-modal" class="select-invoice-modal" :modalClass="'select-invoice-modal'">
      <template slot="modal-header">
        Selecionar transação
      </template>
      <template slot="default">
        <b-row class="mb-2">
          <b-col>
            <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
              <thead>
              <tr>
                <th>Data</th>
                <th>Descrição</th>
                <th>Método de pagamento</th>
                <th>Parcelas</th>
                <th>Valor</th>
                <th>Identificador</th>
                <th>Selecionar</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="invoice in paidInvoices" :key="invoice.id">
                <td>{{ moment(invoice.created_at).format('DD/MM/YYYY HH:mm') }}</td>
                <td>{{ invoice.appointment_id != null ? ('Agendamento ' + invoice.patient) : '-' }}</td>
                <td>{{ invoice.payment_method == 'boleto' ? 'Boleto' : (invoice.payment_method == 'pix' ? 'Pix' : (invoice.card_brand + ' ' + invoice.card_bin + ' ****')) }}</td>
                <td>{{ invoice.installments }}</td>
                <td>R$ {{ formatPrice(invoice.value_in_cents/100.0) }}</td>
                <td>{{ invoice.payment_method == 'boleto' ? invoice.boleto_document_number : (invoice.payment_method == 'pix' ? invoice.pix_id : (invoice.card_nsu != null ? (invoice.card_nsu + '-' + invoice.card_auth) : '')) }}</td>
                <td>
                  <b-button size="sm" variant="primary" @click="selectPaidInvoice(invoice)"><i class="fas fa-check"></i></b-button>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('select-invoice-modal')">Fechar</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
  import axios from "axios";

  export default {
    data() {
      return {
        leavingPage: false,
        user: null,

        termSingular: '',
        termPlural: '',
        url: '',
        letter: '',
        newTerm: '',
        module: '',
        dischargedTerm: '',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        saveAsDraft: false,
        issueNfse: false,

        lockedPaymentFields: false,
        lockedPaymentMethodField: false,

        selectedPatient: null,
        bind_transaction: false,
        new_payer: false,
        new_payer_patient: false,
        payer_patient: null,
        current_payer_has_document: false,

        transactionForm: {
          id: null,
          type: this.$route.meta.type,
          patient: null,
          professional: null,
          payer: null,
          edit_payer: false,
          // bank_account: null,
          cost_center: null,
          unit: null,
          category: null,
          payment_method: null,
          description: '',
          notes: '',
          original_value: '',
          discount: '',
          discount_is_percent: true,
          value: '',
          payment_type: {value: 'no_installments', name: 'À vista'},
          repeat_index: null,
          repeat_times: null,
          registration_date: '',
          charge_date: '',
          discharged: false,
          discharge_date: '',
          discharge_value: '',
          attendance_guide_invoice: null,
          attendance_guide_start_datetime: null,
          attendance_guide_health_plan: '',
          attendance_guide_authorization_code: '',
          attendance_guide_invoice_items: [],
          use_patient_data: false,
          payer_person_id: null,
          payer_name: null,
          payer_fantasy_name: null,
          payer_email: null,
          payer_document: null,
          payer_city_inscription: null,
          payer_state_inscription: null,
          payer_zip_code: null,
          payer_address: null,
          payer_number: null,
          payer_complement: null,
          payer_neighborhood: null,
          payer_city: null,
          payer_state: null,
          payer_country: 'Brazil',
          payer_telephone: null,
          payer_cellphone: null,
          nfse: null,
          payments: [],
          other_installment_transactions: [],
          first_transaction_payments: [],
        },

        chargeDateFieldClass: '',
        professionals: [],
        bank_accounts: [],
        cost_centers: [],
        units: [],
        categories: [],
        payment_methods: [],
        payment_payment_methods: [],

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },

        people: [],
        payers: [],
        payerPatients: [],
        isLoadingPeople: false,
        findPeopleTimer: null,
        isLoadingPayers: false,
        findPayersTimer: null,
        isLoadingPayerPatients: false,
        findPayerPatientsTimer: null,

        split: false,
        splitForm: {
          times: '',
          value: 0,
          installments: []
        },

        paymentTypeOptions: [
          { value: 'no_installments', name: 'À vista' },
          { value: 'installments', name: 'Parcelado' }
        ],

        repeat: false,
        repeatForm: {
          type: { value: 'monthly', name: 'Mensalmente' },
          times: ''
        },

        nfseStatusOptions: [
          { value: 'PROCESSANDO', name: 'Processando' },
          { value: 'CANCELADO', name: 'Cancelada' },
          { value: 'CONCLUIDO', name: 'Emitida' },
          { value: 'DENEGADO', name: 'Denegada' },
          { value: 'REJEITADO', name: 'Rejeitada' }
        ],

        repeatOptions: [
          { value: 'daily', name: 'Diariamente' },
          { value: 'weekly', name: 'Semanalmente' },
          { value: 'biweekly', name: 'Quinzenalmente' },
          { value: 'monthly', name: 'Mensalmente' },
          { value: 'yearly', name: 'Anualmente' }
        ],

        bankAccountForm: {
          name: '',
          opening_balance: 0
        },

        categoryForm: {
          type: '',
          name: ''
        },

        paymentForm: {
          id: null,
          bank_account: null,
          payment_method: null,
          invoice: null,
          date: '',
          original_value: '',
          discount: '',
          interest: '',
          fine: '',
          value: '',
          notes: '',
        },
        paidInvoices: []
      }
    },
    watch: {
      'transactionForm.payment_type': {
        handler(newValue) {
          if(this.transactionForm.id == null || (this.transactionForm.attendance_guide_invoice != null && !this.transactionForm.attendance_guide_invoice.finished_setup)) {
            if (newValue != null && newValue.value == 'installments') {
              this.repeat = false;
              this.split = true;
              if(this.splitForm.times === '') {
                this.splitForm.times = 2;
              }
            }
            else if (newValue != null && newValue.value == 'repeat') {
              this.repeat = true;
              this.split = false;
            }
            else {
              this.repeat = false;
              this.split = false;
              this.splitForm.times = '';
              this.splitForm.installments = [];
            }
          }
        }
      },
      'transactionForm.charge_date': {
        handler(newValue) {
          this.chargeDateFieldClass = '';
          if(newValue != null && !this.transactionForm.discharged) {
            let chargeDate = this.moment(newValue, 'DD/MM/YYYY').endOf('day'),
                daysToChargeDate = chargeDate.diff(this.moment().endOf('day'), 'days', true);
            if(daysToChargeDate < 0) {
              this.chargeDateFieldClass = 'danger';
            }
            else if(daysToChargeDate <= 3) {
              this.chargeDateFieldClass = 'warning';
            }
          }
        }
      },
      'transactionForm.payment_method': {
        handler() {
          this.lockedPaymentMethodField = this.transactionForm.payment_method.name !== 'Múltiplas';
        }
      },
      // 'split': {
      //   handler(newValue) {
      //     if(newValue) {
      //       this.repeat = false;
      //       if(this.splitForm.times === '') {
      //         this.splitForm.times = 2;
      //       }
      //     }
      //     else {
      //       this.splitForm.times = '';
      //       this.splitForm.installments = [];
      //     }
      //   }
      // },
      // 'repeat': {
      //   handler(newValue) {
      //     if(newValue)
      //       this.split = false;
      //   }
      // },
      'splitForm.times': {
        handler(newValue) {
          let remainingValue = this.transactionForm.value,
              splitValue = remainingValue/parseInt(newValue);
          splitValue = splitValue.toFixed(2) * 1.0;
          this.splitForm.value = splitValue;
          this.splitForm.installments = [];
          let chargeDate = this.transactionForm.charge_date;
          if(chargeDate !== '') {
            chargeDate = this.moment(chargeDate, 'DD/MM/YYYY');
          }
          let installmentValues = [];
          for(let index = 1; index <= newValue; index++) {
            if(index == newValue) {
              installmentValues.push(remainingValue);
            }
            else {
              installmentValues.push(splitValue);
              remainingValue -= splitValue;
            }
          }
          installmentValues.sort().reverse();
          for(let index = 1; index <= newValue; index++) {
            if(chargeDate !== '' && index > 1) {
              chargeDate = chargeDate.add(1, 'month');
            }
            this.splitForm.installments.push({
              index: index,
              value: installmentValues[index - 1],
              payment_method: this.transactionForm.payment_method != null ? this.transactionForm.payment_method : null,
              charge_date: chargeDate !== '' ? chargeDate.format('DD/MM/YYYY') : '',
              discharged: false,
              discharge_date: '',
            });
          }
          // console.log(this.splitForm.installments)
        }
      },
      'transactionForm.original_value': {
        handler() {
          this.calculateLiquidValue();
        }
      },
      'transactionForm.discount': {
        handler() {
          this.calculateLiquidValue();
        }
      },
      'transactionForm.discount_is_percent': {
        handler() {
          this.calculateLiquidValue();
        }
      },
      'transactionForm.value': {
        handler(newValue) {
          if(this.split) {
            let splitValue = newValue/parseInt(this.splitForm.times);
            this.splitForm.value = splitValue;
          }
        }
      },
      'paymentForm.original_value': {
        handler() {
          this.calculatePaymentValue();
        }
      },
      'paymentForm.discount': {
        handler() {
          this.calculatePaymentValue();
        }
      },
      'paymentForm.interest': {
        handler() {
          this.calculatePaymentValue();
        }
      },
      'paymentForm.fine': {
        handler() {
          this.calculatePaymentValue();
        }
      },
      'paymentForm.date': {
        handler() {
          this.checkPaymentInvoice();
        }
      },
      'paymentForm.payment_method': {
        handler() {
          this.checkPaymentInvoice();
        }
      },
      'paymentForm.value': {
        handler() {
          this.checkPaymentInvoice();
        }
      },

      // 'transactionForm.use_patient_data': {
      //   handler(newValue) {
      //     if(newValue && this.selectedPatient != null) {
      //       this.transactionForm.payer_name = this.selectedPatient.name;
      //       this.transactionForm.payer_email = this.selectedPatient.email;
      //       this.transactionForm.payer_document = this.selectedPatient.document;
      //       this.transactionForm.payer_telephone = this.selectedPatient.telephone;
      //       this.transactionForm.payer_cellphone = this.selectedPatient.cellphone;
      //       if(this.selectedPatient.address != null) {
      //         this.transactionForm.payer_zip_code = this.selectedPatient.address.zip_code;
      //         this.transactionForm.payer_address = this.selectedPatient.address.address;
      //         this.transactionForm.payer_number = this.selectedPatient.address.number;
      //         this.transactionForm.payer_complement = this.selectedPatient.address.complement;
      //         this.transactionForm.payer_neighborhood = this.selectedPatient.address.neighborhood;
      //         this.transactionForm.payer_city = this.selectedPatient.address.city;
      //         this.transactionForm.payer_state = this.selectedPatient.address.state;
      //         this.transactionForm.payer_country = this.selectedPatient.address.country;
      //       }
      //     }
      //   }
      // }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      if (this.$route.meta.type == 'INCOME') {
        this.termSingular = 'conta a receber';
        this.termPlural = 'contas a receber';
        this.url = 'contas-a-receber';
        this.letter = 'a';
        this.newTerm = 'cadastrar-conta-a-receber';
        this.dischargedTerm = 'recebido';
        this.module = 'incomes';
      }
      else if (this.$route.meta.type == 'EXPENSE') {
        this.termSingular = 'conta a pagar';
        this.termPlural = 'contas a pagar';
        this.url = 'contas-a-pagar';
        this.letter = 'a';
        this.newTerm = 'cadastrar-conta-a-pagar';
        this.dischargedTerm = 'pago';
        this.module = 'expenses';
      }

      this.canSee = (this.helpers.isOwner()) ? true : this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner()) ? true : this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner()) ? true : this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner()) ? true : this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner()) ? true : this.helpers.checkPermission(this.module, 'can_manage');
      if (this.canSee == false || !this.helpers.planHasPermission('financial')) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({path: '/'}).catch(() => {});
        return;
      }
      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      await this.api.getTransactionFormData({module: this.module}).then(res => {
        if (this.leavingPage) {
          return;
        }
        this.professionals = [];
        res.data.professionals.forEach(professional => {
          this.professionals.push({value: professional.id, name: professional.name});
        });
        this.bank_accounts = [];
        res.data.bank_accounts.forEach(category => {
          this.bank_accounts.push({value: category.id, name: category.name});
        });
        this.cost_centers = [];
        res.data.cost_centers.forEach(category => {
          this.cost_centers.push({value: category.id, name: category.name});
        });
        this.payment_methods = [];
        this.payment_payment_methods = [];
        res.data.payment_methods.forEach(category => {
          this.payment_methods.push({value: category.id, name: category.name});
          if(category.name !== 'Múltiplas') {
            this.payment_payment_methods.push({value: category.id, name: category.name});
          }
        });
        this.categories = [];
        res.data[this.module].forEach(category => {
          this.categories.push({value: category.id, name: category.name});
        });
        this.units = [];
        res.data.units.forEach(unit => {
          this.units.push({value: unit.id, name: unit.display_name});
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Transaction Form Data', res);
      }).catch(err => {
        if (this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar os dados! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Transaction Form Data', err.response);
      });

      if (this.$route.params.id != this.newTerm) {
        await this.api.getTransaction(this.$route.params.id).then(res => {
          this.canPerformAction = true;
          if (this.leavingPage) {
            return;
          }

          let transactionData = res.data;

          if(transactionData.attendance_guide_invoice == null) {
            this.paymentTypeOptions.push({ value: 'repeat', name: 'Recorrente' });
          }

          let dentistSpecialty = transactionData.professional != null ? transactionData.professional.specialities.find(specialty => {
            return specialty.group === 'Odontologia';
          }) : undefined;
          this.transactionForm = {
            id: transactionData.id,
            type: transactionData.type,
            patient: (transactionData.patient != null) ? {
              value: transactionData.patient.id,
              name: transactionData.patient.name,
              email: transactionData.patient.email,
              document: transactionData.patient.document,
              telephone: transactionData.patient.telephone,
              cellphone: transactionData.patient.cellphone,
              address: transactionData.patient.address
            } : null,
            professional: (transactionData.professional != null) ? {
              value: transactionData.professional.id,
              name: transactionData.professional.name,
              commission_percentage: transactionData.professional.commission_percentage,
              is_dentist: dentistSpecialty !== undefined,
            } : null,
            payer: transactionData.payer,
            edit_payer: false,
            // bank_account: (transactionData.bank_account != null) ? {
            //   value: transactionData.bank_account.id,
            //   name: transactionData.bank_account.name
            // } : null,
            cost_center: (transactionData.cost_center != null) ? {
              value: transactionData.cost_center.id,
              name: transactionData.cost_center.name
            } : null,
            category: (transactionData.category != null) ? {
              value: transactionData.category.id,
              name: transactionData.category.name
            } : null,
            payment_method: (transactionData.payment_method != null) ? {
              value: transactionData.payment_method.id,
              name: transactionData.payment_method.name
            } : null,
            unit: this.units.find(d => d.value == transactionData.unit_id),
            repeat_id: transactionData.repeat_id,
            description_prefix: '',
            description: transactionData.description,
            notes: transactionData.notes,
            original_value: transactionData.original_value,
            discount: transactionData.discount,
            discount_is_percent: transactionData.discount_is_percent == 1,
            value: transactionData.value,
            payment_type: transactionData.payment_type != null ? this.paymentTypeOptions.find(g => g.value == transactionData.payment_type) : {value: 'no_installments', name: 'À vista'},
            repeat_index: transactionData.repeat_index,
            repeat_times: transactionData.repeat_times,
            registration_date: this.moment(transactionData.registration_date).format('DD/MM/YYYY'),
            charge_date: transactionData.charge_date != null ? this.moment(transactionData.charge_date).format('DD/MM/YYYY') : '',
            discharged: transactionData.discharged,
            discharge_date: (this.moment(transactionData.discharge_date).isValid()) ? this.moment(transactionData.discharge_date).format('DD/MM/YYYY') : '',
            discharge_value: transactionData.discharge_value,
            attendance_guide_invoice: transactionData.attendance_guide_invoice,
            attendance_guide_internal_id: transactionData.attendance_guide_internal_id,
            attendance_guide_start_datetime: transactionData.attendance_guide_start_datetime != null ? this.moment(transactionData.attendance_guide_start_datetime).format('DD/MM/YYYY HH:mm') : null,
            attendance_guide_health_plan: transactionData.attendance_guide_health_plan,
            attendance_guide_invoice_items: transactionData.attendance_guide_invoice_items,
            use_patient_data: false,
            payer_person_id: null,
            payer_name: transactionData.payer_name,
            payer_fantasy_name: transactionData.payer_fantasy_name,
            payer_email: transactionData.payer_email,
            payer_document: transactionData.payer_document,
            payer_city_inscription: transactionData.payer_city_inscription,
            payer_state_inscription: transactionData.payer_state_inscription,
            payer_zip_code: transactionData.payer_zip_code,
            payer_address: transactionData.payer_address,
            payer_number: transactionData.payer_number,
            payer_complement: transactionData.payer_complement,
            payer_neighborhood: transactionData.payer_neighborhood,
            payer_city: transactionData.payer_city,
            payer_state: transactionData.payer_state,
            payer_country: transactionData.payer_country != null ? transactionData.payer_country : 'Brazil',
            payer_telephone: transactionData.payer_telephone,
            payer_cellphone: transactionData.payer_cellphone,
            nfse: transactionData.nfse,
            payments: [],
            other_installment_transactions: transactionData.other_installment_transactions,
            first_transaction_payments: [],
          };

          if(transactionData.attendance_guide_internal_id) {
            this.transactionForm.description_prefix = '#' + transactionData.attendance_guide_internal_id;
            this.transactionForm.description = this.transactionForm.description.replace(this.transactionForm.description_prefix + ' -', '').trim();
          }
          if(transactionData.payment_type === 'installments') {
            if(this.transactionForm.description_prefix != '') {
              this.transactionForm.description_prefix += ' - ';
            }
            let installments = '(' + transactionData.repeat_times + 'x)';
            if(this.transactionForm.description.indexOf(installments) === 0) {
              this.transactionForm.description_prefix += installments;
              this.transactionForm.description = this.transactionForm.description.replace(installments, '').trim();
            }
            else {
              let installment = '(' + transactionData.repeat_index + '/' + transactionData.repeat_times + ')';
              this.transactionForm.description_prefix += installment;
              this.transactionForm.description = this.transactionForm.description.replace(installment, '').trim();
            }
          }
          if (this.transactionForm.payer != null) {
            this.transactionForm.payer.value = this.transactionForm.payer.id;
          }
          this.selectedPatient = this.transactionForm.patient;
          this.bind_transaction = this.transactionForm.patient != null || this.transactionForm.professional != null;

          transactionData.payments.forEach(payment => {
            let invoice = (payment.invoice != null) ? {
                  id: payment.invoice.id,
                  payment_method: payment.invoice.payment_method,
                  appointment_id: payment.invoice.appointment_id,
                  patient: payment.invoice.appointment != null ? payment.invoice.appointment.patient.name : null,
                  card_brand: payment.invoice.card_brand,
                  card_bin: payment.invoice.card_bin,
                  boleto_document_number: payment.invoice.boleto_document_number,
                  pix_id: payment.invoice.pix_id,
                  card_nsu: payment.invoice.card_nsu,
                  card_auth: payment.invoice.card_auth,
                  paid_at: payment.invoice.paid_at,
                  installments: payment.invoice.installments,
                  value_in_cents: payment.invoice.value_in_cents,
                } : null;
            this.transactionForm.payments.push({
              id: payment.id,
              bank_account: (payment.bank_account_id != null) ? this.bank_accounts.find(g => g.value == payment.bank_account_id) : null,
              payment_method: (payment.payment_method_id != null) ? this.payment_payment_methods.find(g => g.value == payment.payment_method_id) : null,
              invoice: invoice,
              date: payment.date,
              original_value: payment.original_value,
              discount: payment.discount,
              interest: payment.interest,
              fine: payment.fine,
              value: payment.value,
              notes: payment.notes,
            });
          });
          transactionData.first_transaction_payments.forEach(payment => {
            let invoice = (payment.invoice != null) ? {
                  id: payment.invoice.id,
                  payment_method: payment.invoice.payment_method,
                  appointment_id: payment.invoice.appointment_id,
                  patient: payment.invoice.appointment != null ? payment.invoice.appointment.patient.name : null,
                  card_brand: payment.invoice.card_brand,
                  card_bin: payment.invoice.card_bin,
                  boleto_document_number: payment.invoice.boleto_document_number,
                  pix_id: payment.invoice.pix_id,
                  card_nsu: payment.invoice.card_nsu,
                  card_auth: payment.invoice.card_auth,
                  paid_at: payment.invoice.paid_at,
                  installments: payment.invoice.installments,
                  value_in_cents: payment.invoice.value_in_cents,
                } : null;
            this.transactionForm.first_transaction_payments.push({
              id: payment.id,
              bank_account: (payment.bank_account_id != null) ? this.bank_accounts.find(g => g.value == payment.bank_account_id) : null,
              payment_method: (payment.payment_method_id != null) ? this.payment_payment_methods.find(g => g.value == payment.payment_method_id) : null,
              invoice: invoice,
              date: payment.date,
              original_value: payment.original_value,
              discount: payment.discount,
              interest: payment.interest,
              fine: payment.fine,
              value: payment.value,
              notes: payment.notes,
            });
          });
          if(this.$route.meta.type == 'INCOME' && this.transactionForm.nfse != null && this.transactionForm.nfse.value == this.transactionForm.payments.reduce((total, item) => total + item.value, 0)) {
            this.lockedPaymentFields = true;
          }
          if(!this.lockedPaymentFields && this.transactionForm.discharged && this.transactionForm.payments.length === 0 && this.transactionForm.first_transaction_payments.length > 0) {
            this.lockedPaymentFields = true;
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Transaction', res);
        }).catch(err => {
          if (this.leavingPage) {
            return;
          }
          this.$router.push({path: '/financeiro/' + this.url}).catch(() => {});

          this.$swal('Ops...', 'Não conseguimos carregar esta ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Transaction', err.response);
        });
      }
      else {
        this.paymentTypeOptions.push({ value: 'repeat', name: 'Recorrente' });
        this.transactionForm.registration_date = this.moment().format('DD/MM/YYYY');
        this.transactionForm.unit = this.units.find(d => d.value == this.user.person.client.default_unit.id);
        this.canPerformAction = true;
      }
      this.eventBus.$emit('IS_LOADING', false);
    },
    methods: {
      // getBankAccounts() {
      //   this.api.getBankAccounts().then(res => {
      //     if (this.leavingPage) {
      //       return;
      //     }
      //     this.bank_accounts = [];
      //     res.data.forEach(category => {
      //       this.bank_accounts.push({value: category.id, name: category.name});
      //     });
      //
      //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //       console.log('Response Bank Accounts', res);
      //   }).catch(err => {
      //     if (this.leavingPage) {
      //       return;
      //     }
      //     this.$swal('Ops...', 'Não conseguimos carregar as contas bancárias! Por favor, entre em contato com o suporte!', 'error');
      //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //       console.log('Error Bank Accounts', err.response);
      //   });
      // },

      // getCategory(category) {
      //   this.api.getCategories({ type: category }).then(res => {
      //     if(this.leavingPage) {
      //       return;
      //     }
      //     let categoriesAux = [];
      //     res.data.forEach(category => {
      //       categoriesAux.push({value: category.id, name: category.name});
      //     });
      //
      //     if(category == 'cost_center') {
      //       this.cost_centers = categoriesAux;
      //     } else if(category == 'incomes' || category == 'expenses') {
      //       this.categories = categoriesAux;
      //     } else if(category == 'payment_method') {
      //       this.payment_methods = categoriesAux;
      //     }
      //
      //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //       console.log('Response Categories', res);
      //   }).catch(err => {
      //     if(this.leavingPage) {
      //       return;
      //     }
      //     this.$swal('Ops...', 'Não conseguimos carregar as categorias! Por favor, entre em contato com o suporte!', 'error');
      //     if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //       console.log('Error Categories', err.response);
      //   });
      // },

      resetBankAccountModal() {
        this.bankAccountForm = {
          name: '',
          opening_balance: 0
        };
      },

      resetPaymentModal() {
        this.paymentForm = {
          id: null,
          bank_account: null,
          payment_method: null,
          invoice: null,
          date: '',
          original_value: '',
          discount: '',
          interest: '',
          fine: '',
          value: '',
          notes: '',
        };
      },

      showPaymentModal(payment) {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;
        if(payment == null) {
          let pendingValue = this.transactionForm.value - this.transactionForm.payments.reduce((total, item) => total + item.original_value, 0);
          this.paymentForm = {
            id: null,
            bank_account: null,
            payment_method: this.transactionForm.payment_method && this.transactionForm.payment_method.name !== 'Múltiplas' ? this.transactionForm.payment_method : null,
            invoice: null,
            date: this.moment().format('DD/MM/YYYY'),
            original_value: pendingValue > 0 ? pendingValue : '',
            discount: '',
            interest: '',
            fine: '',
            value: '',
            notes: '',
          }
        }
        else {
          this.paymentForm = this.helpers.clone(payment);
          this.paymentForm.date = this.moment(payment.date).format('DD/MM/YYYY');
        }

        this.$bvModal.show('payment-modal');
        this.canPerformAction = true;
      },

      async deletePayment(index) {
        this.transactionForm.payments.splice(index, 1);
        let currentPaymentTotal = this.transactionForm.payments.reduce((total, item) => total + item.original_value, 0);
        this.transactionForm.discharged = currentPaymentTotal >= this.transactionForm.value;
      },

      async savePayment() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;
        const isValid = await this.$refs.paymentForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        if(this.user.person.client.enable_mandic_nf && ['Cartão de Crédito', 'Cartão de Débito', 'Pix'].indexOf(this.paymentForm.payment_method.name) >= 0 && this.paymentForm.invoice == null) {
          this.canPerformAction = true;
          this.$swal('Ops...', 'Você precisa selecionar a transação para continuar!', 'error');
          return false;
        }

        let payment = this.helpers.clone(this.paymentForm);
        payment.date = this.moment(this.paymentForm.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        if(payment.id == null) {
          payment.id = this.helpers.uuidv4();
          this.transactionForm.payments.push(payment);
        }
        else {
          let oldPayment = this.transactionForm.payments.find(r => r.id == payment.id),
              index = this.transactionForm.payments.indexOf(oldPayment);
          this.transactionForm.payments.splice(index, 1, payment)
        }

        let currentPaymentTotal = this.transactionForm.payments.reduce((total, item) => total + item.original_value, 0);
        this.transactionForm.discharged = currentPaymentTotal >= this.transactionForm.value;

        this.$bvModal.hide('payment-modal');
        this.canPerformAction = true;
      },

      calculateLiquidValue() {
        let value = this.transactionForm.original_value;
        if(this.transactionForm.discount > 0) {
          value -= this.transactionForm.discount_is_percent ? (value * this.transactionForm.discount/100.0) : this.transactionForm.discount;
        }
        this.transactionForm.value = value;
        if(this.split) {
          let splitValue = value/parseInt(this.splitForm.times);
          this.splitForm.value = splitValue;
        }
      },

      calculatePaymentValue() {
        let value = this.paymentForm.original_value;
        if(this.paymentForm.discount > 0) {
          value -= this.paymentForm.discount;
        }
        if(this.paymentForm.interest > 0) {
          value += this.paymentForm.interest;
        }
        if(this.paymentForm.fine > 0) {
          value += this.paymentForm.fine;
        }
        this.paymentForm.value = value;
      },

      getPaymentMethodName(paymentMethod) {
        if(['Cartão de Crédito', 'Cartão de Débito', 'Pix'].indexOf(paymentMethod) === -1) {
          return null;
        }
        if(paymentMethod == 'Cartão de Crédito') {
          return 'credit';
        }
        else if(paymentMethod == 'Cartão de Débito') {
          return 'debit';
        }
        else {
          return 'pix';
        }
      },

      showSelectInvoiceModal() {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit)))
          return false;

        if(this.isNullOrEmpty(this.paymentForm.date)) {
          this.$swal('Ops...', 'Você precisa preencher a data para selecionar a transação!', 'error');
          return false;
        }
        if(this.isNullOrEmpty(this.paymentForm.original_value) || this.paymentForm.original_value == 0) {
          this.$swal('Ops...', 'Você precisa preencher o valor original para selecionar a transação!', 'error');
          return false;
        }
        if(this.paymentForm.value == 0) {
          this.$swal('Ops...', 'O valor final não pode ser R$ 0,00!', 'error');
          return false;
        }
        if(this.transactionForm.unit == null) {
          this.$swal('Ops...', 'Você precisa selecionar a unidade para selecionar a transação!', 'error');
          return false;
        }
        let paymentData = { date: this.paymentForm.date, value: this.paymentForm.value, payment_method: this.getPaymentMethodName(this.paymentForm.payment_method.name), unit_id: this.transactionForm.unit.value };

        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);
        this.paidInvoices = [];

        this.api.getPaidInvoices(paymentData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.paidInvoices = res.data;
          if(this.paidInvoices.length > 0) {
            this.$bvModal.show('select-invoice-modal');
          }
          else {
            this.$swal('Ops...', 'Não foi encontrada nenhuma transação com esses dados.', 'error');
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Get Paid Invoices', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let message = 'Não conseguimos as transações! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
          if(err.response && err.response.status == 400 && err.response.data.message) {
            message = err.response.data.message;
          }
          this.$swal('Ops...', message, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Get Paid Invoices', err.response);
        });
      },

      selectPaidInvoice(invoice) {
        this.paymentForm.invoice = invoice;
        this.$bvModal.hide('select-invoice-modal');
      },

      checkPaymentInvoice() {
        if(this.paymentForm.invoice != null) {
          let paymentMethod = this.getPaymentMethodName(this.paymentForm.payment_method.name);
          if((paymentMethod == null || this.paymentForm.invoice.payment_method != paymentMethod) || this.moment(this.paymentForm.invoice.paid_at).format('DD/MM/YYYY') !== this.paymentForm.date || this.paymentForm.invoice.value_in_cents !== parseInt(this.paymentForm.value*100)) {
            this.paymentForm.invoice = null;
          }
        }
      },

      showBankAccountModal() {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;

        this.$bvModal.show('bank-account-modal');
        this.canPerformAction = true;
      },

      async saveBankAccount() {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.bankAccountForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        this.eventBus.$emit('IS_LOADING', true);
        this.api.storeBankAccount(this.bankAccountForm).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          if (res.status == 201) {
            let newCategory = { value: res.data.id, name: res.data.name };
            this.bank_accounts.push(newCategory);
            this.paymentForm.bank_account = { value: res.data.id, name: res.data.name };

            this.$swal('Uhull \\o/', 'A conta bancária foi criada com sucesso!', 'success');
          } else {
            this.$swal('Ops...', 'Ocorreu um erro ao criar a conta bancária! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          }
          this.$bvModal.hide('bank-account-modal');

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Store Bank Account', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let msg = 'Não conseguimos criar esta conta bancária! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Store Bank Account', err.response);
        });
      },

      resetCategoryModal() {
        this.categoryForm = {
          type: '',
          name: ''
        }
      },

      showCategoryModal(type) {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;
        this.categoryForm.type = type;

        this.$bvModal.show('category-modal');
        this.canPerformAction = true;
      },

      async saveCategory() {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.categoryForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        this.eventBus.$emit('IS_LOADING', true);
        this.api.storeCategory(this.categoryForm).then(res => {
          console.log('oi');
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          if (res.status == 201) {
            let newCategory = { value: res.data.id, name: res.data.name };
            if(this.categoryForm.type == 'cost_center') {
              this.cost_centers.push(newCategory);
              this.transactionForm.cost_center = newCategory;
            } else if(this.categoryForm.type == 'incomes' || this.categoryForm.type == 'expenses') {
              this.categories.push(newCategory);
              this.transactionForm.category = newCategory;
            }

            if(this.categoryForm.type == 'cost_center') {
              this.$swal('Uhull \\o/', 'O centro de custo foi criado com sucesso!', 'success');
            } else if(this.categoryForm.type == 'incomes' || this.categoryForm.type == 'expenses') {
              this.$swal('Uhull \\o/', 'A categoria foi criada com sucesso!', 'success');
            }
          } else {
            if(this.categoryForm.type == 'cost_center') {
              this.$swal('Ops...', 'Ocorreu um erro ao criar o centro de custo! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            } else if(this.categoryForm.type == 'incomes' || this.categoryForm.type == 'expenses') {
              this.$swal('Ops...', 'Ocorreu um erro ao criar a categoria! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }
          }
          this.$bvModal.hide('category-modal');

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Store Category', res);
        }).catch(err => {
          console.log('tchau');
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let msg = '';
          if(this.categoryForm.type == 'cost_center') {
            msg = 'Não conseguimos criar este centro de custo! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
          } else if(this.categoryForm.type == 'incomes' || this.categoryForm.type == 'expenses') {
            msg = 'Não conseguimos criar esta categoria! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
          }

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Store Category', err.response);
        });
      },

      async installmentPaymentMethodSelected(selectedOption) {
        if(selectedOption.index == 1) {
          this.$refs.installmentPaymentMethod1[0].deactivate();
          await this.$swal({
            title: 'Aplicar para as demais?',
            text: 'Você quer aplicar esta forma de pagamento para as demais parcelas/lançamentos?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              this.splitForm.installments.forEach(installment => {
                if(installment.index > 1) {
                  installment.payment_method = selectedOption.payment_method;
                }
              });
              this.transactionForm.payment_method = selectedOption.payment_method;
            }
          });
        }

        let selectedOptions = [];
        this.splitForm.installments.forEach(installment => {
          if(installment.payment_method && selectedOptions.indexOf(installment.payment_method) === -1) {
            selectedOptions.push(installment.payment_method);
          }
        });
        if(selectedOptions.length === 1) {
          this.transactionForm.payment_method = selectedOptions[0];
        }
        else {
          this.transactionForm.payment_method = this.payment_methods.find(g => g.name === 'Múltiplas');
        }
      },

      async saveInvoiceDraft() {
        let doSave = false;

        if(this.split) {
          await this.$swal({
            title: 'Você tem certeza?',
            text: 'Ao salvar como rascunho, as informações de parcelamento e pagamento serão perdidas. Você terá que preenchê-las novamente quando for finalizar o faturamento.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doSave = true;
            }
          });
        }
        else {
          doSave = true;
        }
        if(doSave) {
          this.saveAsDraft = true;
          await this.saveTransaction();
        }
      },

      async finishInvoiceSetup() {
        let doSave = false;

        await this.$swal({
          title: 'Você tem certeza?',
          text: 'Ao finalizar o faturamento, as informações não poderão mais ser alteradas. Somente será possível informar o recebimento ou excluir.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            doSave = true;
          }
        });
        if(doSave) {
          await this.saveTransaction();
        }
      },

      async issueTransactionNf() {
        let doSave = false;

        let form = this.transactionForm,
          isCompany = form.payer_document != null && form.payer_document.length === 18;

        if(this.transactionForm.attendance_guide_invoice != null && this.user.person.client.enable_mandic_nf) {
          let cnaes = [],
              emptyInternalCodeOrCnae = false;
          this.transactionForm.attendance_guide_invoice_items.forEach(item => {
            if(cnaes.indexOf(item.procedure.cnae) === -1) {
              cnaes.push(item.procedure.cnae);
            }
            if(!emptyInternalCodeOrCnae && (item.procedure.internal_code == null || item.procedure.cnae == null)) {
              emptyInternalCodeOrCnae = true;
            }
          });
          if(cnaes.length > 1) {
            this.$swal('Ops...', 'Não é possível emitir NF com procedimentos de CNAEs diferentes.', 'error');
            return false;
          }
          if(emptyInternalCodeOrCnae) {
            this.$swal('Ops...', 'Os procedimentos devem ter o código interno e o CNAE preenchidos para emitir NF.', 'error');
            return false;
          }
        }

        if(this.isNullOrEmpty(form.payer_document) || this.isNullOrEmpty(form.payer_name) || (isCompany && (this.isNullOrEmpty(form.payer_city_inscription)/* || this.isNullOrEmpty(form.payer_state_inscription)*/)) ||
            this.isNullOrEmpty(form.payer_email) || (this.isNullOrEmpty(form.payer_telephone) && this.isNullOrEmpty(form.payer_cellphone)) || this.isNullOrEmpty(form.payer_zip_code) || this.isNullOrEmpty(form.payer_address) ||
            this.isNullOrEmpty(form.payer_number) || this.isNullOrEmpty(form.payer_neighborhood) || this.isNullOrEmpty(form.payer_city) || this.isNullOrEmpty(form.payer_state)) {
          let missingFields = [];
          if(this.isNullOrEmpty(form.payer_document)) {
            missingFields.push('CPF / CNPJ');
          }
          if(this.isNullOrEmpty(form.payer_name)) {
            missingFields.push(isCompany ? 'razão social' : 'nome');
          }
          if(isCompany) {
            if(this.isNullOrEmpty(form.payer_city_inscription)) {
              missingFields.push('inscrição municipal');
            }
            if(this.isNullOrEmpty(form.payer_state_inscription)) {
              missingFields.push('inscrição estadual');
            }
          }
          if(this.isNullOrEmpty(form.payer_email)) {
            missingFields.push('e-mail');
          }
          if(this.isNullOrEmpty(form.payer_telephone) && this.isNullOrEmpty(form.payer_cellphone)) {
            missingFields.push('telefone (ou celular)');
          }
          if(this.isNullOrEmpty(form.payer_zip_code) || this.isNullOrEmpty(form.payer_address) || this.isNullOrEmpty(form.payer_number) || this.isNullOrEmpty(form.payer_neighborhood) || this.isNullOrEmpty(form.payer_city) || this.isNullOrEmpty(form.payer_state)) {
            missingFields.push('endereço completo');
          }
          missingFields = missingFields.join(', ').replace(/,(?=[^,]*$)/, ' e');

          this.$swal('Ops...', 'Você precisa preencher o ' + missingFields + ' do cliente para emitir NF!', 'error');
          return false;
        }

        if(this.transactionForm.value == 0) {
          this.$swal('Ops...', 'O valor final não pode ser R$ 0,00!', 'error');
          return false;
        }

        let message = 'Ao emitir a NF, as informações não poderão mais ser alteradas. Somente será possível informar o recebimento ou excluir.';
        if(this.transactionForm.payments.length === 0 && this.transactionForm.first_transaction_payments.length === 0) {
          message = 'Você ainda não informou nenhum pagamento para este lançamento, então o valor da NF será de R$ ' + this.formatPrice(this.transactionForm.value) + '. Ao emitir a NF, as informações não poderão mais ser alteradas. Somente será possível informar pagamento(s) ou excluir.';
        }
        else if(this.transactionForm.discharged && this.transactionForm.first_transaction_payments.length > 0) {
          message = 'O valor da NF será de R$ ' + this.formatPrice(this.transactionForm.discharge_value) + '. Ao emitir a NF, as informações não poderão mais ser alteradas. Somente será possível excluir.';
        }
        else if(this.transactionForm.value != this.transactionForm.payments.reduce((total, item) => total + item.original_value, 0)) {
          message = 'O valor da NF será de R$ ' + this.formatPrice(this.transactionForm.payments.reduce((total, item) => total + item.value, 0)) + '. Ao emitir a NF, as informações não poderão mais ser alteradas. Somente será possível excluir.';
        }

        await this.$swal({
          title: 'Você tem certeza?',
          text: message,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            doSave = true;
          }
        });
        if(doSave) {
          this.issueNfse = true;
          await this.saveTransaction();
        }
      },

      async saveTransaction() {
        if(!this.canPerformAction || !((this.transactionForm.id == null && this.canAdd) || (this.transactionForm.id != null && this.canEdit))) {
          this.saveAsDraft = false;
          return false;
        }

        if(this.split) {
          if(this.splitForm.times == '' || this.splitForm.times < 2) {
            this.$swal('Ops...', 'O pagamento parcelado deve ter ao menos 2 parcelas!', 'error');
            return false;
          }
          let value = this.transactionForm.value,
              installmentsValue = 0;

          this.splitForm.installments.forEach(installment => {
            installmentsValue += installment.value;
          });
          installmentsValue = installmentsValue.toFixed(2) * 1.0;
          if(value != installmentsValue) {
            this.$swal('Ops...', 'O valor total das parcelas está diferente do campo Valor!', 'error');
            return false;
          }
        }

        this.canPerformAction = false;

        const isValid = await this.$refs.transactionForm.validate();
        if(!isValid) {
          this.saveAsDraft = false;
          this.issueNfse = false;
          this.canPerformAction = true;
          return false;
        }
        if(this.transactionForm.payments.length > 0 && this.transactionForm.payment_method.name !== 'Múltiplas') {
          let invalidPaymentPaymentMethod = false;
          this.transactionForm.payments.forEach(payment => {
            if(payment.payment_method.value !== this.transactionForm.payment_method.value) {
              invalidPaymentPaymentMethod = true;
              return false;
            }
          });
          if(invalidPaymentPaymentMethod) {
            this.saveAsDraft = false;
            this.issueNfse = false;
            this.canPerformAction = true;
            this.$swal('Ops...', 'Há pagamento(s) informado(s) com forma de pagamento diferente da forma de pagamento do lançamento! Caso estejam corretos, utilize a forma de pagamento "Múltiplas" em seu lançamento.', 'error');
            return false;
          }
        }

        let dischargeValue = this.transactionForm.payments.reduce((total, item) => total + item.value, 0);
        if(dischargeValue === 0 && this.transactionForm.discharged && this.transactionForm.first_transaction_payments.length > 0) {
          dischargeValue = this.transactionForm.discharge_value;
        }

        let transactionData = {
          id: this.transactionForm.id,
          type: this.$route.meta.type,
          patient_id: (this.transactionForm.patient != null)?this.transactionForm.patient.value:null,
          professional_id: (this.transactionForm.professional != null)?this.transactionForm.professional.value:null,
          edit_payer: this.transactionForm.edit_payer ? 1 : 0,
          payer_id: this.transactionForm.payer != null ? this.transactionForm.payer.value : null,
          payer_person_id: this.transactionForm.payer_person_id,
          payer_name: this.transactionForm.payer_name,
          payer_fantasy_name: this.transactionForm.payer_fantasy_name,
          payer_email: this.transactionForm.payer_email,
          payer_document: this.transactionForm.payer_document,
          payer_city_inscription: this.transactionForm.payer_city_inscription,
          payer_state_inscription: this.transactionForm.payer_state_inscription,
          payer_zip_code: this.transactionForm.payer_zip_code,
          payer_address: this.transactionForm.payer_address,
          payer_number: this.transactionForm.payer_number,
          payer_complement: this.transactionForm.payer_complement,
          payer_neighborhood: this.transactionForm.payer_neighborhood,
          payer_city: this.transactionForm.payer_city,
          payer_state: this.transactionForm.payer_state,
          payer_country: this.transactionForm.payer_country,
          payer_telephone: this.transactionForm.payer_telephone,
          payer_cellphone: this.transactionForm.payer_cellphone,
          // bank_account_id: (this.transactionForm.bank_account != null)?this.transactionForm.bank_account.value:null,
          cost_center_id: (this.transactionForm.cost_center != null)?this.transactionForm.cost_center.value:null,
          category_id: (this.transactionForm.category != null)?this.transactionForm.category.value:null,
          payment_method_id: this.transactionForm.payment_method != null ? this.transactionForm.payment_method.value : null,
          payment_type: this.transactionForm.payment_type != null ? this.transactionForm.payment_type.value : null,
          unit_id: this.transactionForm.unit.value,
          description_prefix: this.transactionForm.description_prefix,
          description: this.transactionForm.description,
          notes: this.transactionForm.notes,
          original_value: this.transactionForm.original_value,
          discount: this.transactionForm.discount,
          discount_is_percent: this.transactionForm.discount_is_percent,
          value: this.transactionForm.value,
          registration_date: this.transactionForm.registration_date,
          charge_date: this.transactionForm.charge_date,
          discharged: this.transactionForm.discharged,
          discharge_value: dischargeValue,
          // discharge_date: this.transactionForm.discharge_date,
          save_as_draft: this.saveAsDraft ? 1 : 0,
          issue_nfse: this.issueNfse ? 1 : 0,
          payments: []
        };

        if(this.split || this.repeat) {
          transactionData.repeat = {
            method: (this.split)?'split':'repeat',
            times: (this.split)?this.splitForm.times:this.repeatForm.times,
            installments: [],
            recurrence: (this.repeat)?this.repeatForm.type.value:null
          };
          if(this.split) {
            this.splitForm.installments.forEach(installment => {
              transactionData.repeat.installments.push({
                value: (installment.value*1.0).toFixed(2) * 1.0,
                payment_method_id: installment.payment_method.value,
                charge_date: installment.charge_date,
                // discharged: installment.discharged,
                // discharge_date: installment.discharge_date,
              });
            });
          }
        }

        this.transactionForm.payments.forEach(payment => {
          transactionData.payments.push({
            id: payment.id,
            bank_account_id: payment.bank_account.value,
            payment_method_id: payment.payment_method.value,
            invoice_id: payment.invoice != null ? payment.invoice.id : null,
            date: payment.date,
            original_value: payment.original_value,
            discount: payment.discount,
            interest: payment.interest,
            fine: payment.fine,
            value: payment.value,
            notes: payment.notes,
          });
        });

        this.eventBus.$emit('IS_LOADING', true);
        if (this.transactionForm.id == null) {
          this.api.storeTransaction(transactionData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.saveAsDraft = false;
            this.issueNfse = false;

            if (res.status == 201) {
              this.$swal('Uhull \\o/', 'A '+this.termSingular+' foi criada com sucesso!', 'success').then(() => {
                this.$router.push({path: '/financeiro/'+this.url+'/'+res.data.id}).catch(() => {});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao criar a '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Transaction', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.saveAsDraft = false;
            this.issueNfse = false;

            try {
              let msg = 'Não conseguimos criar esta '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 422: msg = err.response.data.errors.join('\r\n'); break;
                case 400: if(err.response.data.message) { msg = err.response.data.message; } break;
              }

              this.$swal('Ops...', msg, 'error');
            } catch(err2) {
              this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchStoreTransaction\nError:'+err.toString(), 'warning');
              this.sentry.captureException(err);
            }
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Transaction', err.response);
          });
        } else {
          this.api.updateTransaction(this.transactionForm.id, transactionData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.saveAsDraft = false;
            this.issueNfse = false;

            if (res.status == 200) {
              this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi atualizada com sucesso!', 'success').then(() => {
                this.$router.go();
                // this.$router.push({path: '/financeiro/'+this.url}).catch(() => {});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Transaction', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.saveAsDraft = false;
            this.issueNfse = false;

            let message = 'Não conseguimos atualizar esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
            let response = err.response;
            switch (response.status) {
              case 422: message = response.data.errors.join('\r\n'); break;
              case 400: {
                if(typeof response.data.message != 'undefined' && response.data.message != '') {
                  message = response.data.message;
                }
                break;
              }
            }
            let reload = response.data.reload;
            this.$swal('Ops...', message, 'error').then(() => {
              if(reload) {
                this.$router.go();
              }
            });
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Transaction', err.response);
          });
        }
      },

      async deleteTransactionNf() {
        if(this.canRemove) {
          let doCancel = false;

          await this.$swal({
            title: 'Você tem certeza?',
            text: 'A NF não será cancelada, será apenas excluída do sistema. Esta ação não poderá ser desfeita!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doCancel = true;
            }
          });

          if(doCancel) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
              this.api.deleteTransactionNf(this.transactionForm.id).then(res => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                if (res.status == 204) {
                  this.$swal('Uhull \\o/', 'A NF foi excluída com sucesso!', 'success').then(() => {
                    this.$router.go();
                  });
                } else {
                  this.$swal('Ops...', 'Ocorreu um erro ao excluir a NF! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
                }

                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Response Delete Transaction Nfse', res);
              }).catch(err => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                this.$swal('Ops...', 'Não conseguimos excluir esta NF! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Error Delete Transaction Nfse', err.response);
              });
          }
        }
      },

      async deleteTransaction() {
        if(this.canRemove) {
          let doCancel = false;
          let deleteType = 'this';

          if(this.transactionForm.repeat_id != null) {
            await this.$swal({
              title: 'Excluir ' + this.termSingular + ' recorrente',
              input: 'select',
              inputOptions: {
                this: 'Esta ' + this.termSingular,
                future: 'Esta e as ' + this.termPlural + ' futuras',
                all: 'Todas as ' + this.termPlural
              },
              showCancelButton: true,
              cancelButtonText: 'Cancelar',
              inputValidator: (value) => {
                deleteType = value;
              }
            }).then((res) => {
              console.log(res);
              if(res.value) {
                doCancel = true;
              }
            });
          }
          else {
            await this.$swal({
              title: 'Você tem certeza?',
              text: 'Esta ação não poderá ser desfeita!',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancelar',
              focusCancel: true
            }).then((res) => {
              if(res.value) {
                doCancel = true;
              }
            });
          }

          if(doCancel) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
              this.api.deleteTransaction(this.transactionForm.id, deleteType).then(res => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                if (res.status == 204) {
                  this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi excluída com sucesso!', 'success').then(() => {
                    this.$router.push({path: '/financeiro/'+this.url}).catch(() => {});
                  });
                } else {
                  this.$swal('Ops...', 'Ocorreu um erro ao excluir a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
                }

                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Response Delete Transaction', res);
              }).catch(err => {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;
                this.$swal('Ops...', 'Não conseguimos excluir esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Error Delete Transaction', err.response);
              });
          }
        }
      },

      limitPeople(qty) {
        return 'e '+qty+' outros pacientes';
      },

      findPeople(query) {
        this.people = [];
        if(query.length >= 3 && !this.isLoadingPeople) {
          if(this.findPeopleTimer !== null) {
            clearTimeout(this.findPeopleTimer);
          }
          this.findPeopleTimer = setTimeout(() => {
            this.isLoadingPeople = true;
            this.api.getPeople({ type: 'PATIENT', name: query }).then(res => {
              if(this.leavingPage) {
                return;
              }
              this.isLoadingPeople = false;

              res.data.data.forEach(patient => {
                this.people.push({
                  value: patient.id,
                  name: patient.name,
                  email: patient.email,
                  document: patient.document,
                  telephone: patient.telephone,
                  cellphone: patient.cellphone,
                  address: patient.address
                });
              });
            }).catch(err => {
              if(this.leavingPage) {
                return;
              }
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Patients', err.response);
            });
          }, 300);
        }
      },

      findPayerPatients(query) {
        this.payerPatients = [];
        if(query.length >= 3 && !this.isLoadingPeople) {
          if(this.findPayerPatientsTimer !== null) {
            clearTimeout(this.findPayerPatientsTimer);
          }
          this.findPayerPatientsTimer = setTimeout(() => {
            this.isLoadingPeopleisLoadingPayerPatients = true;
            this.api.getPeople({ type: 'PATIENT', name: query }).then(res => {
              if(this.leavingPage) {
                return;
              }
              this.isLoadingPayerPatients = false;

              res.data.data.forEach(patient => {
                this.payerPatients.push({
                  value: patient.id,
                  name: patient.name,
                  email: patient.email,
                  document: patient.document,
                  telephone: patient.telephone,
                  cellphone: patient.cellphone,
                  address: patient.address
                });
              });
            }).catch(err => {
              if(this.leavingPage) {
                return;
              }
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Payer Patients', err.response);
            });
          }, 300);
        }
      },

      limitPayers(qty) {
        return 'e '+qty+' outros ' + (this.$route.meta.type == 'INCOME' ? 'clientes' : 'fornecedores');
      },

      findPayers(query) {
        this.people = [];
        if(query.length >= 3 && !this.isLoadingPayers) {
          if(this.findPayersTimer !== null) {
            clearTimeout(this.findPayersTimer);
          }
          this.findPayersTimer = setTimeout(() => {
            this.isLoadingPayers = true;
            this.api.getPayers({ name: query }).then(res => {
              if(this.leavingPage) {
                return;
              }
              this.isLoadingPayers = false;

              res.data.data.forEach(payer => {
                this.payers.push({
                  value: payer.id,
                  document: payer.document,
                  name: payer.formatted_name,
                  payer_name: payer.name,
                  fantasy_name: payer.fantasy_name,
                  email: payer.email,
                  telephone: payer.telephone,
                  city_inscription: payer.city_inscription,
                  state_inscription: payer.state_inscription,
                  address: payer.address
                });
              });
            }).catch(err => {
              if(this.leavingPage) {
                return;
              }
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Payers', err.response);
            });
          }, 300);
        }
      },

      findCep(value) {
        if(value == '00000-000' || value == '99999-999') {
          this.transactionForm.payer_address = 'Atendimento online';
          this.transactionForm.payer_number = '-';
          this.transactionForm.payer_neighborhood = '-';
          this.transactionForm.payer_city = '-';
          this.transactionForm.payer_state = '-';
        } else if(value != null && value.length == 9) {
          axios.get('https://viacep.com.br/ws/'+value+'/json/').then(res => {
            if(typeof res.data.erro == 'undefined') {
              let cepData = res.data;
              this.transactionForm.payer_address = cepData.logradouro;
              this.transactionForm.payer_neighborhood = cepData.bairro;
              this.transactionForm.payer_city = cepData.localidade;
              this.transactionForm.payer_state = cepData.uf;

              this.$refs.number.$el.focus();
            } else {

              this.$refs.address.$el.focus();
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response CEP', res);
          }).catch(err => {
            this.$swal('Ops...', 'Não conseguimos localizar o seu CEP! Por favor, preencha os dados manualmente.', 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error CEP', err.response);
          });
        }
      },

      patientSelected(selectedOption) {
        if(this.$route.meta.type == 'INCOME') {
          this.selectedPatient = {
            name: selectedOption.name,
            email: selectedOption.email,
            telephone: selectedOption.telephone,
            cellphone: selectedOption.cellphone,
            document: selectedOption.document,
            address: selectedOption.address
          }
        }
      },

      payerSelected(selectedOption) {
        this.new_payer = false;
        this.new_payer_patient = false;
        this.payer_patient = null;
        this.transactionForm.edit_payer = false;
        this.current_payer_has_document = selectedOption.document != null && selectedOption.document != '';
        this.transactionForm.payer = selectedOption;
        this.transactionForm.payer_person_id = null;
        this.transactionForm.payer_name = selectedOption.payer_name;//name é um campo formatado
        this.transactionForm.payer_fantasy_name = selectedOption.fantasy_name;
        this.transactionForm.payer_email = selectedOption.email;
        this.transactionForm.payer_document = selectedOption.document;
        this.transactionForm.payer_telephone = selectedOption.telephone;
        this.transactionForm.payer_cellphone = selectedOption.cellphone;
        if(selectedOption.address != null) {
          this.transactionForm.payer_zip_code = selectedOption.address.zip_code;
          this.transactionForm.payer_address = selectedOption.address.address;
          this.transactionForm.payer_number = selectedOption.address.number;
          this.transactionForm.payer_complement = selectedOption.address.complement;
          this.transactionForm.payer_neighborhood = selectedOption.address.neighborhood;
          this.transactionForm.payer_city = selectedOption.address.city;
          this.transactionForm.payer_state = selectedOption.address.state;
          this.transactionForm.payer_country = selectedOption.address.country;
        }
      },

      payerPatientSelected(selectedOption) {
        this.transactionForm.edit_payer = false;
        this.current_payer_has_document = selectedOption.document != null && selectedOption.document != '';
        this.transactionForm.payer_person_id = selectedOption.value;
        this.transactionForm.payer_name = selectedOption.name;
        this.transactionForm.payer_email = selectedOption.email;
        this.transactionForm.payer_document = selectedOption.document;
        this.transactionForm.payer_telephone = selectedOption.telephone;
        this.transactionForm.payer_cellphone = selectedOption.cellphone;
        if(selectedOption.address != null) {
          this.transactionForm.payer_zip_code = selectedOption.address.zip_code;
          this.transactionForm.payer_address = selectedOption.address.address;
          this.transactionForm.payer_number = selectedOption.address.number;
          this.transactionForm.payer_complement = selectedOption.address.complement;
          this.transactionForm.payer_neighborhood = selectedOption.address.neighborhood;
          this.transactionForm.payer_city = selectedOption.address.city;
          this.transactionForm.payer_state = selectedOption.address.state;
          this.transactionForm.payer_country = selectedOption.address.country;
        }
      },

      newPayer() {
        this.transactionForm.use_patient_data = false;
        this.transactionForm.payer = null;
        this.transactionForm.payer_person_id = null;
        this.transactionForm.payer_name = this.$refs.multiselectPayer.search;
        this.transactionForm.payer_document = null;
        this.current_payer_has_document = false;
        this.new_payer = true;
        this.new_payer_patient = false;
        this.payer_patient = null;
      },

      newPayerWithPatientData() {
        this.transactionForm.use_patient_data = true;
        this.transactionForm.payer = null;
        this.new_payer = true;
        this.new_payer_patient = true;
        this.payer_patient = this.transactionForm.patient;
        this.payerPatientSelected(this.transactionForm.patient);
      },

      newPayerPatient() {
        this.transactionForm.use_patient_data = false;
        this.transactionForm.payer = null;
        this.new_payer = true;
        this.new_payer_patient = true;
        this.transactionForm.payer_person_id = null;
        this.transactionForm.payer_name = null;
        this.transactionForm.payer_document = null;
      },

      changePayer() {
        this.transactionForm.use_patient_data = false;
        this.transactionForm.payer = null;
        this.current_payer_has_document = false;
        this.new_payer = false;
        this.new_payer_patient = false;
        this.payer_patient = null;
        this.transactionForm.edit_payer = false;
        this.transactionForm.payer_person_id = null;
        this.transactionForm.payer_name = null;
        this.transactionForm.payer_fantasy_name = null;
        this.transactionForm.payer_email = null;
        this.transactionForm.payer_document = null;
        this.transactionForm.payer_city_inscription = null;
        this.transactionForm.payer_state_inscription = null;
        this.transactionForm.payer_zip_code = null;
        this.transactionForm.payer_address = null;
        this.transactionForm.payer_number = null;
        this.transactionForm.payer_complement = null;
        this.transactionForm.payer_neighborhood = null;
        this.transactionForm.payer_city = null;
        this.transactionForm.payer_state = null;
        this.transactionForm.payer_country = 'Brazil';
        this.transactionForm.payer_telephone = null;
        this.transactionForm.payer_cellphone = null;
        this.$forceUpdate();
      },

      recalculateInstallments() {
        let remainingValue = this.transactionForm.value,
            splitValue = remainingValue/parseInt(this.splitForm.times);
        splitValue = splitValue.toFixed(2) * 1.0;
        this.splitForm.value = splitValue;
        let installmentValues = [];
        for(let index = 1; index <= this.splitForm.times; index++) {
          if(index == this.splitForm.times) {
            installmentValues.push(remainingValue);
          }
          else {
            installmentValues.push(splitValue);
            remainingValue -= splitValue;
          }
        }
        installmentValues.sort().reverse();
        this.splitForm.installments.forEach(installment => {
          installment.value = installmentValues[installment.index - 1];
        });
      },

      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      isNullOrEmpty(value) {
        return value == null || value == '';
      },

      goBack() {
        this.$router.push({path: '/financeiro/' + this.url}).catch(() => {});
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      if(this.findPeopleTimer !== null) {
        clearTimeout(this.findPeopleTimer);
      }
      if(this.findPayersTimer !== null) {
        clearTimeout(this.findPayersTimer);
      }
      if(this.findPayerPatientsTimer !== null) {
        clearTimeout(this.findPayerPatientsTimer);
      }
      next();
    }
  }
</script>

<style lang="scss">
  .transaction-form {
    padding: 20px 0;

    .text1 {
      font-size: 14px;
      color: $cadetGray;
      margin-bottom: 0;
    }
    .text-warning-darker {
      color: $yellowSeaDarker;
    }


  }
</style>
